import React, { useState, useEffect,useRef } from "react";
import { useSelector } from "react-redux";
import Radio from '@mui/material/Radio';
import Chip from '@mui/material/Chip';
import AddIcon from '@mui/icons-material/Add';
import toast from 'react-hot-toast'
import { TimePicker,DatePicker } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import logo from '../../assets/images/gohijaz.png'
import shiraka_dummy_logo from '../../assets/images/shirka_logo.jpg'
import { useAuthContext } from '../../hooks/agencyAuthHook'
import ConfigurationsHook from '../../hooks/ConfigurationsHook';
import DefaultConfigHook from '../../hooks/DefaultConfigHook';
import InstructionsHook from '../../hooks/InstructionsHook';
import VoucherColorsHook from '../../hooks/VoucherColorsHook';

import PackagesHook from '../../hooks/PackagesHook';
import { Link } from 'react-router-dom'
import { Dialog } from '@mui/material'
import hajj_package from '../../assets//images/hajj_package.png'
import old_design from '../../assets//images/old_design/2152177.jpg'
import new_design from '../../assets//images/new_design/2100934.jpg'

import umrah_package from '../../assets//images/umrah_package.png'

import moment from "moment";
import ProfileHook from '../../hooks/ProfileHook';

export default function Packages() {
  const apiUrl = process.env.REACT_APP_API_URL;

  const { agency } = useAuthContext()
  const { getConfigurations } = ConfigurationsHook();
  const { getDefaultConfigurations } = DefaultConfigHook();
  const { getInstructions } = InstructionsHook();
  const { getVoucherColors } = VoucherColorsHook();

  const { getAgencyProfile } = ProfileHook();
  const { getPackages } = PackagesHook();
  const [newPackage, setNewPackage] = useState(false)
  const [isNewDesign, setIsNewDesign] = useState(true)
  const [package_header, setpackage_header] = useState('umrah package')
  const profile = useSelector((state) => state.profile.profile);
  
  let isAgencyProfile = profile && profile?.role?.toLowerCase().includes('agency')
  
  const collapsed = useSelector((state) => state.collapsed.collapsed);
  const packages = useSelector((state) => state.packages.packages);
  const configurations = useSelector((state) => state.configurations.configurations);
  const defaultconfigurations = useSelector((state) => state.defaultconfigurations.defaultconfigurations);
  const instructions = useSelector((state) => state.instructions.instructions);
  const vouchercolors = useSelector((state) => state.vouchercolors.vouchercolors);


  const [transport_details, settransport_details] = useState();
  const [transport_services_for, settransport_services_for] = useState('');
  const [facilities, setfacilities] = useState([]);
  const [ziyarat, setziyarat] = useState('');

  useEffect(() => {
    document.title = "Packages"
      getAgencyProfile()
      getPackages()
      getDefaultConfigurations()
      getConfigurations() 
      getInstructions()   
    getVoucherColors()

  }, [profile])



  const handleToggleTransport = (chip) => {
    // Toggle selection: deselect if clicked again, otherwise set as selected
    settransport_details(transport_details === chip ? null : chip);
  };


  const handleToggleTrasportServicesFor = (chip) => {
    settransport_services_for(transport_services_for === chip ? null : chip);
  };

  const handleToggleFacilities = (chip) => {
    if (facilities.includes(chip)) {
      setfacilities(facilities.filter((c) => c !== chip)); // Remove if already selected
    } else {
      setfacilities([...facilities, chip]); // Add if not selected
    }
  }

  const handleToggleZiyarat = (chip) => {
    setziyarat(ziyarat === chip ? null : chip);
  };
  // States 
  const [package_title, setpackage_title] = useState('')
  const [package_code, setpackage_code] = useState('')
  const [package_type, setpackage_type] = useState('')
  const [total_slots, settotal_slots] = useState()
  const [cover_image, setcover_image] = useState('')
  const [package_description, setpackage_description] = useState('')
  const [duration, setduration] = useState()
  // const [price, setprice] = useState('')
  // const [discounted_price, setdiscounted_price] = useState('')

  // Flights Details
  // Departure Flights Details
  const [departure_airline_name, setdeparture_airline_name] = useState('')
  const [departure_airline_id, setdeparture_airline_id] = useState('')

  const [departure_flight_class, setdeparture_flight_class] = useState('')
  const [departure_flight_number, setdeparture_flight_number] = useState('')
  const [departure_location, setdeparture_location] = useState('')
  const [departure_location_id, setdeparture_location_id] = useState('')


  const [departure_flight_date, setdeparture_flight_date] = useState('')
  const [departure_time, setdeparture_time] = useState(null)

  const [departure_to_location, setdeparture_to_location] = useState('')
  const [departure_to_location_id, setdeparture_to_location_id] = useState('')

  const [departure_to_flight_date, setdeparture_to_flight_date] = useState('')
  const [departure_to_time, setdeparture_to_time] = useState('')

  // Departure Flights Details
  const [arrival_airline_name, setarrival_airline_name] = useState('')
  const [arrival_airline_id, setarrival_airline_id] = useState('')

  const [arrival_flight_class, setarrival_flight_class] = useState('')
  const [arrival_flight_number, setarrival_flight_number] = useState('')
  const [arrival_location, setarrival_location] = useState('')
  const [arrival_location_id, setarrival_location_id] = useState('')

  const [arrival_flight_date, setarrival_flight_date] = useState('')
  const [arrival_time, setarrival_time] = useState('')
  
  const [take_off_location, settake_off_location] = useState('')
  const [take_off_location_id, settake_off_location_id] = useState('')

  const [take_off_flight_date, settake_off_flight_date] = useState('')
  const [take_off_time, settake_off_time] = useState('')


  // Details in case of hotels incusion or not
  const [isHotel, setIsHotel] = useState(true)
  const [adults_price, setadults_price] = useState()
  const [adults_currency, setadults_currency] = useState('PKR')

  const [childs_price, setchilds_price] = useState()
  const [childs_currency, setchilds_currency] = useState('PKR')

  const [infant_price, setinfant_price] = useState()
  const [infant_currency, setinfant_currency] = useState('PKR')

  const [openNew, setOpenNew] = React.useState(false);

  

  const handleClickOpenNew = () => {
    setOpenNew(true);

  };

  const handleNewPackage = () => {
    const letestPackages = packages && packages.filter(p => p.package_header.trim().toLowerCase() === package_header.trim().toLowerCase())
    if (letestPackages.length > 0) {
      let latestRelatedPackage = letestPackages[letestPackages.length - 1]
      settransport_details(latestRelatedPackage.transport_details)
      settransport_services_for(latestRelatedPackage.transport_services_for)
      setfacilities(latestRelatedPackage.facilities)
      setziyarat(latestRelatedPackage.ziyarat)
      setdeparture_airline_name(latestRelatedPackage.departure_flight?.departure_airline_name || '')

      setdeparture_airline_id(latestRelatedPackage.departure_flight?.departure_airline_id || '')
      setdeparture_flight_class(latestRelatedPackage.departure_flight?.departure_flight_class || '')
      setdeparture_flight_number(latestRelatedPackage.departure_flight?.departure_flight_number || '')

      setdeparture_location(latestRelatedPackage.departure_flight?.departure_location || '')
      setdeparture_location_id(latestRelatedPackage.departure_flight?.departure_location_id || '')

      setdeparture_to_location(latestRelatedPackage.departure_flight?.departure_to_location || '')
      setdeparture_to_location_id(latestRelatedPackage.departure_flight?.departure_to_location_id || '')

    }

    setOpenNew(false)
    setNewPackage(true);
  }

  const handleCloseNew = () => {
    setOpenNew(false);
    setpackage_header('umrah package')
  }
  

  dayjs.extend(customParseFormat);



  const[localArrival_Date,setLocalArrivalDate]=useState('')
  const[localArrivalTo_Date,setLocalArrivalToDate]=useState('')

  useEffect(() => {
    if (departure_flight_date && duration) {
      const calculatedDate = dayjs(departure_flight_date, "DD/MM/YYYY")
        .add(Number(duration), "days")
        .format("DD/MM/YYYY");
  
      setarrival_flight_date(localArrival_Date ? localArrival_Date : calculatedDate);
      setdeparture_to_flight_date(dayjs(departure_flight_date, "DD/MM/YYYY").format("DD/MM/YYYY")); // Default date input format
      settake_off_flight_date(localArrivalTo_Date ? localArrivalTo_Date : calculatedDate);
    }
  }, [departure_flight_date, duration]);
  
  useEffect(() => {
    if (departure_location_id) {
      settake_off_location_id(departure_location_id)
    }
  }, [departure_location_id])

  useEffect(() => {
    if (departure_to_location_id) {
      setarrival_location_id(departure_to_location_id)
    }
  }, [departure_to_location_id])


  // useEffect(() => {
  //   if (departure_airline_id) {
  //     setarrival_airline_id(departure_airline_id)
  //   }
  // }, [departure_airline_id])
  // useEffect(() => {
  //   if (departure_flight_class) {
  //     setarrival_flight_class(departure_flight_class)
  //   }
  // }, [departure_flight_class])

  // Hajj Package Details
  const [departure_from, setdeparture_from] = useState('')
  const [departure_from_id, setdeparture_from_id] = useState('')

  const [category, setcategory] = useState('')
  const [zone, setzone] = useState('')
  const [distance_from_makkah_hotel, setdistance_from_makkah_hotel] = useState('')
  const [distance_from_madina_hotel, setdistance_from_madina_hotel] = useState('')
  const [transport, settransport] = useState('')
  const [mina_transport, setmina_transport] = useState('')
  const [ziayarat_included, setziayarat_included] = useState(false)
  const [gifts_included, setgifts_included] = useState(false)
  const [food_included, setfood_included] = useState('')
  const [qurbani_included, setqurbani_included] = useState(false)
  const [azizia_included, setazizia_included] = useState(false)
  const [markazia_included, setmarkazia_included] = useState(false)

  const initialPricing = [
    {
      room_type: package_header === 'hajj package' ? duration : '',
      first_price: { price: 0, currency: 'PKR' },
      second_price: { price: 0, currency: 'PKR' },
      third_price: { price: 0, currency: 'PKR' },
      ...(package_header === 'hajj package' && {
        fourth_price: { price: 0, currency: 'PKR' }
      })
    }
  ];

  const [pricing, setpricing] = useState(initialPricing);

  const handleAddRow = () => {

    const latestPricing = pricing[pricing.length - 1]

    const newPricing = {
      room_type: '',
      first_price: { price: 0, currency: latestPricing?.first_price?.currency || "PKR" },
      second_price: { price: latestPricing?.second_price?.price || 0, currency: latestPricing?.second_price?.currency || "PKR" },
      third_price: { price: latestPricing?.third_price?.price || 0, currency: latestPricing?.third_price?.currency || "PKR" },
    };
    setpricing([...pricing, newPricing]);
  };

  const handleDeleteRow = (index) => {
    setpricing(pricing.filter((_, i) => i !== index));
  };

  const handlePricingInputChange = (index, field, value) => {
    const fieldParts = field.split('.');

    setpricing(
      pricing && pricing.map((item, i) => {
        if (i !== index) return item;

        if (fieldParts.length > 1) {
          const isPriceField = fieldParts[1] === 'price';
          return {
            ...item,
            [fieldParts[0]]: {
              ...item[fieldParts[0]],
              [fieldParts[1]]: isPriceField ? Number(value) : value,
            },
          };
        }

        return { ...item, [field]: value };
      })
    );
  }

  // Hotels Array Details
  const [accomodation_details, setaccomodation_details] = useState([
    {
      hotel_duration: '',
      hotel_city: 'makkah',
      hotel_name: '',
      hotel_id: '',
      check_in_date: '',
      check_out_date: ''
    },
    {
      hotel_duration: '',
      hotel_city: 'madinah',
      hotel_name: '',
      hotel_id: '',
      check_in_date: '',
      check_out_date: ''
    },
    {
      hotel_duration: '',
      hotel_city: 'makkah',
      hotel_name: '',
      hotel_id: '',
      check_in_date: '',
      check_out_date: ''
    },
  ]);

  const handleAddHotelRow = () => {
    const newHotel = {
      hotel_duration: '',
      hotel_city: '',
      hotel_name: '',
      hotel_id: '',
      check_in_date: '',
      check_out_date: ''
    };
    setaccomodation_details([...accomodation_details, newHotel]);
  };


  const handleDeleteHotelRow = (index) => {
    setaccomodation_details(accomodation_details.filter((_, i) => i !== index));
  };


  const handleHotelInputChange = (index, field, value) => {
    const fieldParts = field.split('.');

    setaccomodation_details(
      accomodation_details.map((item, i) => {
        if (i !== index) return item;

        // Handle nested field updates
        if (fieldParts.length > 1) {
          return {
            ...item,
            [fieldParts[0]]: {
              ...item[fieldParts[0]],
              [fieldParts[1]]: value,
            },
          };
        }

        // Handle hotel_name and update hotel_id accordingly
        if (field === 'hotel_name') {
          let hotelId

          const agencyConfigu = configurations?.find(
            (config) => config.title.trim().toLowerCase() === value.trim().toLowerCase()
          );
          if(agencyConfigu){
            hotelId=agencyConfigu._id
          }
          else{
            const defaultConfigu = defaultconfigurations?.find(
              (config) => config?.name?.trim().toLowerCase() === value.trim().toLowerCase()
            );
            if(defaultConfigu){
            hotelId=defaultConfigu._id
            }
          }

          return {
            ...item,
            hotel_name: value,
            hotel_id: hotelId || '',
          };
        }

        // Default field update
        return { ...item, [field]: value };
      })
    );
  

  } 



  // Update Accommodation details check in/out date.
  const prevAccomodationDetails = useRef([]);

  useEffect(() => {
    if (accomodation_details.length > 0) {
      const prevDetails = prevAccomodationDetails.current;
      const currentDetails = accomodation_details;
  
      // Detect changes
      const checkInChanged = prevDetails?.[0]?.check_in_date !== currentDetails[0]?.check_in_date;
  
      // Detect index where check_out_date was changed
      let changedCheckOutIndex = -1;
      for (let i = 0; i < currentDetails.length; i++) {
        if (prevDetails?.[i]?.check_out_date !== currentDetails[i]?.check_out_date) {
          changedCheckOutIndex = i;
          break;
        }
      }
  
      // Apply full logic if first check_in_date changed
      if (checkInChanged) {
        const updatedHotels = accomodation_details.map((hotel, index) => {
          if (index === 0) {
            const checkInDate = dayjs(
              departure_flight_date || hotel.check_in_date,
              "DD/MM/YYYY"
            ).format("DD/MM/YYYY");
  
            const checkOutDate = hotel.hotel_duration
              ? dayjs(checkInDate, "DD/MM/YYYY")
                  .add(Number(hotel.hotel_duration), "days")
                  .format("DD/MM/YYYY")
              : "";
  
            return { ...hotel, check_in_date: checkInDate, check_out_date: checkOutDate };
          } else {
            const previousHotel = accomodation_details[index - 1];
            const checkInDate = previousHotel.check_out_date || "";
            const checkOutDate = hotel.hotel_duration
              ? dayjs(checkInDate, "DD/MM/YYYY")
                  .add(Number(hotel.hotel_duration), "days")
                  .format("DD/MM/YYYY")
              : "";
  
            return { ...hotel, check_in_date: checkInDate, check_out_date: checkOutDate };
          }
        });
  
        setaccomodation_details(updatedHotels);
      }
  
      // If only check_out_date of an intermediate hotel changed
      else if (changedCheckOutIndex !== -1 && changedCheckOutIndex + 1 < accomodation_details.length) {
        const updatedHotels = [...accomodation_details];
  
        for (let i = changedCheckOutIndex + 1; i < updatedHotels.length; i++) {
          const previousHotel = updatedHotels[i - 1];
          const checkInDate = previousHotel.check_out_date || "";
          const checkOutDate = updatedHotels[i].hotel_duration
            ? dayjs(checkInDate, "DD/MM/YYYY")
                .add(Number(updatedHotels[i].hotel_duration), "days")
                .format("DD/MM/YYYY")
            : "";
  
          updatedHotels[i] = {
            ...updatedHotels[i],
            check_in_date: checkInDate,
            check_out_date: checkOutDate,
          };
        }
  
        setaccomodation_details(updatedHotels);
      }
  
      // Save current state as previous for next run
      prevAccomodationDetails.current = accomodation_details;
    }
  }, [accomodation_details, departure_flight_date]);
  

// 2. When only accomodation details change -> handle if needed (optional)
// useEffect(() => {
//   if (accomodation_details.length > 0) {
//     const updatedHotels = accomodation_details.map((hotel, index) => {
//       if (index === 0) {
//         const checkInDate = hotel.check_in_date || ""; // Use the existing check_in_date (from previous set)
//         const checkOutDate = hotel.hotel_duration
//           ? dayjs(checkInDate, "DD/MM/YYYY")
//               .add(Number(hotel.hotel_duration), "days")
//               .format("DD/MM/YYYY")
//           : "";
//         return { ...hotel, check_in_date: checkInDate, check_out_date: checkOutDate };
//       } else {
//         const previousHotel = accomodation_details[index - 1];
//         const checkInDate = previousHotel?.check_out_date || "";
//         const checkOutDate = hotel.hotel_duration
//           ? dayjs(checkInDate, "DD/MM/YYYY")
//               .add(Number(hotel.hotel_duration), "days")
//               .format("DD/MM/YYYY")
//           : "";
//         return { ...hotel, check_in_date: checkInDate, check_out_date: checkOutDate };
//       }
//     });

//     setaccomodation_details(updatedHotels);
//   }
// }, [accomodation_details]);



  useEffect(() => {

    const totalHotelDuration = accomodation_details.reduce(
      (total, hotel) => total + Number(hotel.hotel_duration || 0),
      0
    );

    if (isHotel && totalHotelDuration > Number(duration)) {
      // if (Number(duration) > 0) {
      //   toast.error(`Total hotel duration cannot exceed the package duration: ${duration} days`);
      // }

      // Adjust the last updated duration to prevent exceeding the limit
      const remainingDuration = Number(duration) -
        accomodation_details.slice(0, -1).reduce((total, hotel) => total + Number(hotel.hotel_duration || 0), 0);

      setaccomodation_details((prevHotels) =>
        prevHotels.map((hotel, index) =>
          index === prevHotels.length - 1
            ? { ...hotel, hotel_duration: Math.max(remainingDuration, 0).toString() }
            : hotel
        )
      );
    }
  }, [ duration, isHotel]);



  const handleImage = (e) => {
    const file = e.target.files[0];
    TransformFile(file)
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert('File size exceeds the 5MB limit. Please select a smaller file.');
      } else {
        TransformFile(file);
      }
    }
  };

  const TransformFile = (file) => {
    const reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setcover_image(reader.result);
      };
    } else {
      setcover_image('');
    }
  };



  // Resetting Sates
  const [editedPackageId, setEditedPackageId] = useState('')
  const resetFormStates = () => {
    setNewPackage(false)
    setEditedPackageId('')
    setpackage_title('')
    setpackage_code('')
    setpackage_type('')
    settotal_slots()
    setcover_image('')
    setpackage_description('')
    setduration('')
    setdeparture_airline_name('')
    setdeparture_airline_id('')
    setdeparture_flight_class('')
    setdeparture_flight_number('')
    setdeparture_location('')
    setdeparture_location_id('')
    setdeparture_flight_date('')
    setdeparture_time('')

    setdeparture_to_location('')
    setdeparture_to_location_id('')
    setdeparture_to_flight_date('')
    setdeparture_to_time('')

    setarrival_airline_name('')
    setarrival_airline_id('')
    setarrival_flight_class('')
    setarrival_flight_number('')
    setarrival_location('')
    setarrival_location_id('')
    setarrival_flight_date('')
    setarrival_time('')

    setLocalArrivalDate('')
    setLocalArrivalToDate('')


    settake_off_location('')
    settake_off_location_id('')
    settake_off_flight_date('')
    settake_off_time('')
    setaccomodation_details([
      {
        hotel_duration: '',
        hotel_city: 'makkah',
        hotel_name: '',
        hotel_id: '',
        check_in_date: '',
        check_out_date: ''
      },
      {
        hotel_duration: '',
        hotel_city: 'madinah',
        hotel_name: '',
        hotel_id: '',
        check_in_date: '',
        check_out_date: ''
      },
      {
        hotel_duration: '',
        hotel_city: 'makkah',
        hotel_name: '',
        hotel_id: '',
        check_in_date: '',
        check_out_date: ''
      }
    ])
    setIsHotel(true)
    setadults_price()
    setadults_currency('PKR')
    setchilds_price()
    setchilds_currency('PKR')
    setinfant_price()
    setinfant_currency('PKR')
    setdeparture_from('')
    setdeparture_from_id('')
    setcategory('')
    setzone('')
    setdistance_from_makkah_hotel('')
    setdistance_from_madina_hotel('')

    settransport('')
    setmina_transport('')
    setziayarat_included(false)
    setgifts_included(false)
    setfood_included(false)
    setqurbani_included(false)
    setazizia_included(false)
    setmarkazia_included(false)

    setpricing([{ room_type: '', first_price: { price: 0, currency: 'PKR' }, second_price: { price: 0, currency: 'PKR' }, third_price: { price: 0, currency: 'PKR' }, }])
    settransport_details('')
    setfacilities([])
    setziyarat('')
    settransport_services_for('')

  }
  // const editing package 
  const handleEditPackage = (data) => {
if(data.package_header?.trim()?.toLowerCase().includes('umra')){
  setIsNewDesign(true)
}
      
    setNewPackage(true)
    setpackage_header(data.package_header)
    setpackage_title(data.package_title)
    setEditedPackageId(data._id)
    setpackage_code(data.package_code)
    setpackage_type(data.package_type)
    settotal_slots(data.total_slots)
    setcover_image(data.cover_image)
    setpackage_description(data.package_description)
    setduration(data.duration)

    setdeparture_airline_name(data.departure_flight.departure_airline_name)
    setdeparture_airline_id(data.departure_flight.departure_airline_id)

    setdeparture_flight_class(data.departure_flight.departure_flight_class)
    setdeparture_flight_number(data.departure_flight.departure_flight_number)
    setdeparture_location(data.departure_flight.departure_location)
    setdeparture_location_id(data.departure_flight.departure_location_id)

    setdeparture_flight_date(data.departure_flight.departure_flight_date)
    setdeparture_time(data.departure_flight.departure_time)

    setdeparture_to_location(data.departure_flight.departure_to_location)
    setdeparture_to_location_id(data.departure_flight.departure_to_location_id)

    setdeparture_to_flight_date(data.departure_flight.departure_to_flight_date)
    setdeparture_to_time(data.departure_flight.departure_to_time)


    setarrival_airline_name(data.arrival_flight.arrival_airline_name)
    setarrival_airline_id(data.arrival_flight.arrival_airline_id)

    setarrival_flight_class(data.arrival_flight.arrival_flight_class)
    setarrival_flight_number(data.arrival_flight.arrival_flight_number)
    setarrival_location(data.arrival_flight.arrival_location)
    setarrival_location_id(data.arrival_flight.arrival_location_id)

    setarrival_flight_date(data.arrival_flight.arrival_flight_date)
    setLocalArrivalDate(data.arrival_flight.arrival_flight_date)

    setarrival_time(data.arrival_flight.arrival_time)
    settake_off_location(data.arrival_flight.take_off_location)
    settake_off_location_id(data.arrival_flight.take_off_location_id)

    settake_off_flight_date(data.arrival_flight.take_off_flight_date)
    setLocalArrivalToDate(data.arrival_flight.take_off_flight_date)

    settake_off_time(data.arrival_flight.take_off_time)

    setaccomodation_details(data.accomodation_details)
    setIsHotel(data.isHotel)
    setadults_price(data.direct_pricing.adults.adults_price)
    setadults_currency(data.direct_pricing.adults.adults_currency)
    setchilds_price(data.direct_pricing.childs.childs_price)
    setchilds_currency(data.direct_pricing.childs.childs_currency)
    setinfant_price(data.direct_pricing.infant.infant_price)
    setinfant_currency(data.direct_pricing.infant.infant_currency)

    setdeparture_from(data.departure_from)
    setdeparture_from_id(data.departure_from_id)
    setcategory(data.category)
    setzone(data.zone)
    setdistance_from_makkah_hotel(data.distance_from_makkah_hotel)
    setdistance_from_madina_hotel(data.distance_from_madina_hotel)

    settransport(data.transport)
    setmina_transport(data.mina_transport)
    setziayarat_included(data.ziayarat_included)

    setgifts_included(data.gifts_included)
    setfood_included(data.food_included)
    setqurbani_included(data.qurbani_included)
    setazizia_included(data.azizia_included)
    setmarkazia_included(data.markazia_included)
    setpricing(data.pricing)
    settransport_details(data.transport_details)
    setfacilities(data.facilities)
    setziyarat(data.ziyarat)
    settransport_services_for(data.transport_services_for)

   
  }

  const [loading1, setLoading1] = useState(false)
  const handleFormSubmit = async (e) => {
    e.preventDefault()

    setLoading1(true)
    try {
      const response = await fetch(`${apiUrl}/api/agencies/packages/add`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${agency.token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            package_header,
            package_title,
            package_code,
            package_type,
            total_slots: total_slots ? total_slots : 0,
            cover_image,
            package_description,
            duration: duration ? duration.toString() : '',

            pricing: isHotel ? pricing : [],
            departure_flight: {
              departure_airline_name,
              departure_airline_id,
              departure_flight_class,
              departure_flight_number,
              departure_location,
              departure_location_id,
              departure_flight_date,
              departure_time,

              departure_to_location,
              departure_to_location_id,
              departure_to_flight_date,
              departure_to_time,
            },
            arrival_flight: {
              arrival_airline_name,
              arrival_airline_id,
              arrival_flight_class,
              arrival_flight_number,
              arrival_location,
              arrival_location_id,
              arrival_flight_date,
              arrival_time,

              take_off_location,
              take_off_location_id,
              take_off_flight_date,
              take_off_time,
            },

            isHotel,
            direct_pricing: {
              adults: {
                adults_price: adults_price ? adults_price : 0,
                adults_currency: !isHotel ? adults_currency : ''
              },
              childs: {
                childs_price: childs_price ? childs_price : 0,
                childs_currency: !isHotel ? childs_currency : ''
              },
              infant: {
                infant_price: infant_price ? infant_price : 0,
                infant_currency: !isHotel ? infant_currency : ''
              },
            },
            accomodation_details: (isHotel && package_header === 'umrah package') ? accomodation_details : [],
            transport_details:transport_details?transport_details:'',
            transport_services_for:transport_services_for?transport_services_for:'',
            facilities:facilities?facilities:'',
            ziyarat:ziyarat?ziyarat:'',
            departure_from,
            departure_from_id,
            category,
            zone,
            distance_from_makkah_hotel: distance_from_makkah_hotel ? distance_from_makkah_hotel : '',
            distance_from_madina_hotel: distance_from_madina_hotel ? distance_from_madina_hotel : '',
            transport,
            mina_transport,
            ziayarat_included,

            gifts_included,
            azizia_included,
            markazia_included,
            food_included,
            qurbani_included,

          }
        })
      })
      const json = await response.json()
      if (response.ok) {
        toast.success(json.message)
        resetFormStates()
        setLoading1(false)
        getPackages()

      }
      if (!response.ok) {
        toast.error(json.message)
        setLoading1(false)

      }
    } catch (error) {
      toast.error(error.message)
      setLoading1(false)

    }


  }
  const [packageStatus, setPackageStatus] = useState(1)

  const filteredPackages = packages.filter((pkg) => {
    if (packageStatus === 1 && pkg.isActive) {
      return true;
    }
    if (packageStatus === 2 && pkg.isPending) {
      return true;
    }
    if (packageStatus === 3 && !pkg.isActive && !pkg.isPending) {
      return true; // Assuming this condition is for inactive or deleted packages.
    }
    return false;
  })



  //deleting Packages
  const deletePackage = async (_id) => {
    if (window.confirm('Are you sure you want to delete the package?')) {
      toast.promise(
        new Promise(async (resolve, reject) => {
          try {
            const response = await fetch(`${apiUrl}/api/agencies/packages/delete`, {
              method: "DELETE",
              headers: {
                'Authorization': `Bearer ${agency.token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ _id }),
            });
            const json = await response.json();

            if (response.ok) {
              resolve(json.message); // Use actual API message for success
              getPackages()

            }
            if (!response.ok) {
              reject(new Error(json.message || "Failed to delete.")); // Use actual API message for error
            }
          } catch (error) {

            reject(new Error(error.message || "Unexpected error occurred.")); // Handle unexpected errors
          } finally {

          }
        }),
        {
          loading: "Deleting...",
          success: (message) => <b>{message || "Deleted successfully!"}</b>, // Use dynamic message for success
          error: (error) => <b>{error.message || "Failed to delete."}</b>, // Use dynamic message for error
        }
      );
    }

  };

  //updating Package
  const updatePackage = async (e) => {
    e.preventDefault()

    setLoading1(true)
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const response = await fetch(`${apiUrl}/api/agencies/packages/update`, {
            method: "PUT",
            headers: {
              'Authorization': `Bearer ${agency.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              data: {
                _id: editedPackageId,
                package_header,
                package_title,
                package_code,
                package_type,
                total_slots: total_slots ? total_slots : 0,
                cover_image,
                package_description,
                duration: duration ? duration.toString() : '',

                departure_flight: {
                  departure_airline_name,
                  departure_airline_id,
                  departure_flight_class,
                  departure_flight_number,
                  departure_location,
                  departure_location_id,
                  departure_flight_date,
                  departure_time,

                  departure_to_location,
                  departure_to_location_id,
                  departure_to_flight_date,
                  departure_to_time,
                },

                arrival_flight: {
                  arrival_airline_name,
                  arrival_airline_id,
                  arrival_flight_class,
                  arrival_flight_number,
                  arrival_location,
                  arrival_location_id,
                  arrival_flight_date,
                  arrival_time,
                  take_off_location,
                  take_off_location_id,
                  take_off_flight_date,
                  take_off_time,
                },
                isHotel,

                direct_pricing: (!isHotel && editedPackageId) ? {
                  adults: {
                    adults_price: adults_price ? adults_price : 0,
                    adults_currency: !isHotel ? adults_currency : ''
                  },
                  childs: {
                    childs_price: childs_price ? childs_price : 0,
                    childs_currency: !isHotel ? childs_currency : ''
                  },
                  infant: {
                    infant_price: infant_price ? infant_price : 0,
                    infant_currency: !isHotel ? infant_currency : ''
                  },
                } : {},

                accomodation_details: (isHotel && editedPackageId) ? accomodation_details : [],
                pricing: (isHotel && editedPackageId) ? pricing : [],
                transport_details:transport_details?transport_details:'',
                transport_services_for:transport_services_for?transport_services_for:'',
                facilities:facilities?facilities:'',
                ziyarat:ziyarat?ziyarat:'',
                departure_from,
                departure_from_id,
                category,
                zone,
                distance_from_makkah_hotel: distance_from_makkah_hotel ? distance_from_makkah_hotel : '',
                distance_from_madina_hotel: distance_from_madina_hotel ? distance_from_madina_hotel : '',
                transport,
                mina_transport,
                ziayarat_included,
                gifts_included,
                azizia_included,
                markazia_included,
                food_included,
                qurbani_included,
              }
            }),
          });
          const json = await response.json();

          if (response.ok) {
            resolve(json.message);
            resetFormStates()
            setLoading1(false)
            getPackages()
          }
          if (!response.ok) {
            reject(new Error(json.message || "Failed to update.")); // Use actual API message for error
            setLoading1(false)
          }
        } catch (error) {

          reject(new Error(error.message || "Unexpected error occurred.")); // Handle unexpected errors
        } finally {

        }
      }),
      {
        loading: "Updating...",
        success: (message) => <b>{message || "Update successfully!"}</b>, // Use dynamic message for success
        error: (error) => <b>{error.message || "Failed to update."}</b>, // Use dynamic message for error
      }
    );

  }


  //updating Package Status
  const updatePackageStatus = async (_id, content) => {
    if (window.confirm(`Are you sure you want to ${content} the package?`)) {
      toast.promise(
        new Promise(async (resolve, reject) => {
          try {
            const response = await fetch(`${apiUrl}/api/agencies/packages/update/status`, {
              method: "PUT",
              headers: {
                'Authorization': `Bearer ${agency.token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ _id }),
            });
            const json = await response.json();

            if (response.ok) {
              resolve(json.message); // Use actual API message for success
              getPackages()

            }
            if (!response.ok) {
              reject(new Error(json.message || "Failed to update.")); // Use actual API message for error
            }
          } catch (error) {

            reject(new Error(error.message || "Unexpected error occurred.")); // Handle unexpected errors
          } finally {

          }
        }),
        {
          loading: "Updating...",
          success: (message) => <b>{message || "Update successfully!"}</b>, // Use dynamic message for success
          error: (error) => <b>{error.message || "Failed to update."}</b>, // Use dynamic message for error
        }
      );
    }
  }
  //updating Package Status
  const duplicatePackageStatus = async (Id) => {
    if (window.confirm(`Are you sure you want to duplicate the package?`)) {
      toast.promise(
        new Promise(async (resolve, reject) => {
          try {
            const response = await fetch(`${apiUrl}/api/agencies/packages/duplicate`, {
              method: "PUT",
              headers: {
                'Authorization': `Bearer ${agency.token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ Id }),
            });
            const json = await response.json();

            if (response.ok) {
              resolve(json.message); // Use actual API message for success
              getPackages()

            }
            if (!response.ok) {
              reject(new Error(json.message || "Failed to duplicate.")); // Use actual API message for error
            }
          } catch (error) {

            reject(new Error(error.message || "Unexpected error occurred.")); // Handle unexpected errors
          } finally {

          }
        }),
        {
          loading: "Duplicating...",
          success: (message) => <b>{message || "Duplicated successfully!"}</b>, // Use dynamic message for success
          error: (error) => <b>{error.message || "Failed to duplicate."}</b>, // Use dynamic message for error
        }
      );
    }
  }


  const airlineOptions = [
    ...(defaultconfigurations || [])
      .filter((data) => data.type.trim().toLowerCase() === 'airlines')
      .map((data) => ({
        value: data._id,
        label: `${data.name} - ${data.iata_code}`,
      })),
    ...(configurations || [])
      .filter((data) => data.type.trim().toLowerCase() === 'airlines')
      .map((data) => ({
        value: data.title,
        label: data.title,
      })),
  ];

  const handleSelectChange = (selectedOption) => {
    if (!selectedOption) {
      setdeparture_airline_name('');
      setdeparture_airline_id('');
      setarrival_airline_id('');
      setarrival_airline_name('');
      return;
    }

    const value = selectedOption.value;
    const findId =
      defaultconfigurations?.find((c) => c._id === value) ||
      configurations?.find((c) => c.title === value);

    setdeparture_airline_id(value);
    setarrival_airline_id(value);
    setdeparture_airline_name(findId?.name || findId?.title || '');
    setarrival_airline_name(findId?.name || findId?.title || '');
  }




  // Package/Voucher Preview

  const members=[
    {
      name:"Ali",
      ppNo:"IU7868863",
      dob:"01-05-19980",
      age_group:"Adult",
      visa_number:"VS67YO4",
      visa_issue_date:"04-02-2025",
      mofa_date:"16-06-2025"
    },
    {
      name:"Saima Ali",
      ppNo:"IY7358762",
      dob:"28-08-1982",
      age_group:"Adult",
      visa_number:"VE69BO9",
      visa_issue_date:"17-02-2025",
      mofa_date:"16-06-2025"
    },
    {
      name:"Ahmed Ali",
      ppNo:"BT7358762",
      dob:"12-11-2017",
      age_group:"Child",
      visa_number:"TY64X20",
      visa_issue_date:"17-02-2025",
      mofa_date:"16-06-2025"
    },

    {
      name:"Nadia",
      ppNo:"AO0253758",
      dob:"11-04-2024",
      age_group:"Infant",
      visa_number:"",
      visa_issue_date:"",
      mofa_date:""
    },
  ]

   const VoucherPreview = () => {
  // Create a hidden iframe
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';

  document.body.appendChild(iframe);


    // Wait for external stylesheets to load before writing the content
    const printContentString = `
    <!DOCTYPE html>
      <html>
        <head>
          <!-- Bootstrap CSS -->
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
          
          <!-- Font Awesome CSS -->
             <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css" integrity="sha512-Evv84Mr4kqVGRNSgIGL/F/aIDqQb7xQ2vcrdIwxfjThSH8CSR7PBEakCr51Ck+w+/U6swU2Im1vVX0SVk9ABhg==" crossorigin="anonymous" referrerpolicy="no-referrer" />
          <!-- Google Material Icons -->
          <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined">
       <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined">
          <link href="https://fonts.googleapis.com/css2?family=Noto+Nastaliq+Urdu&display=swap" rel="stylesheet">
          
          <title>Booking/Package Preview</title>
         <style>
          @import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Noto+Nastaliq+Urdu:wght@400..700&display=swap');

            @page {
            size: A4;
            margin: 0.2cm;
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
          }
            .header-container span {
              color: #6D76A1;
              font-size: 10px;
              font-weight: 500;
              text-transform:capitalize;
            }
            .header-container strong {
              color: #000;
              font-size: 11px;
              font-weight: 500;
              text-transform:capitalize;
            }
            .header-container h4 {
              color: ${(vouchercolors&&vouchercolors.header_color)?vouchercolors.header_color:"#0C0B0B"};
              text-align: center;
              font-size: 16px;
              font-weight: 600;
              padding:0px
            }
            .header-container small {
              color: #6D76A1;
              text-align: center;
              font-size: 12px;
              font-weight: 500;
              margin:0px;
              padding:0px;
              display:block;
            }

             .header-container .shirka_logo{
             height:40px;
             width:40px;
             }

            .header-container .shirka_logo img{
             height:100%;
             width:100%;
             border-radius:10px;
             object-fit: cover;
             }

            .info_row {
              border-radius: 10px;
             
            }
            .info_row h6 {
             color: ${(vouchercolors&&vouchercolors.header_color)?vouchercolors.header_color:"#0C0B0B"};
              font-size: 14px;
              font-weight: 600;
            }
            .header-logo {
              width: 55px;
              height:55px;
              border-radius:10px;
              object-fit: cover;
            }
           
             
           .table-wrapper {
                border-radius: 5px;
                overflow: hidden;
              }
                .table .thead1{
             background: ${(vouchercolors&&vouchercolors.table_bg_color)?vouchercolors.table_bg_color:"#CF9137"};
              
              border:1px solid ${(vouchercolors&&vouchercolors.table_bg_color)?vouchercolors.table_bg_color:"#CF9137"};
                }
                .table .thead2{
             background: ${(vouchercolors&&vouchercolors.thead_bg_color)?vouchercolors.thead_bg_color:"#FED9A4"};
             
                border:1px solid ${(vouchercolors&&vouchercolors.thead_bg_color)?vouchercolors.thead_bg_color:"#FED9A4"};
                }
            .table th {
             color: black;
           
              font-size: 9px;
              font-weight: 600;
              text-transform:capitalize;
              padding:1.5px;
              border:0px;
            }
              .table tbody{
              border:0.6px solid ${(vouchercolors&&vouchercolors.thead_bg_color)?vouchercolors.thead_bg_color:"#FED9A4"};

              }
              .table tbody tr{
              border:0.6px solid ${(vouchercolors&&vouchercolors.thead_bg_color)?vouchercolors.thead_bg_color:"#FED9A4"};
              }
            .table td {
              color: #0C0B0B;
              font-size: 8px;
              font-weight: 500;
              text-transform:capitalize;
              padding:1.4px;
              border:0px;
            }

            table, tr, td {
              page-break-inside: avoid; /* Prevent splitting tables */
            }
            .instruction, .contact {
              page-break-inside: avoid; /* Prevent breaking within these sections */
            }
              .instruction p, .contact {
                page-break-inside: auto; /* Allow breaking if content is too large */
              }

             .instruction .header {
              color: ${(vouchercolors&&vouchercolors.header_color)?vouchercolors.header_color:"#CF9137"};
             
              font-size: 13px;
              font-weight: 600;
            }
               .instruction .inner{
               border-radius:4px;
               height:auto;
               }
            
            .instruction .urdu_paragraph *{
              font-size: 8px !important;
              line-height: 2.3 !important;
              margin: 0;
              padding: 0;
            }
            .ql-align-left {
                text-align: left !important;
                direction: ltr;
              }

              .ql-align-center {
                text-align: center !important;
                direction: ltr;
              }

              .ql-align-right {
                text-align: right !important;
                direction: rtl;
              }
             .urdu_font{
            font-family: "Noto Nastaliq Urdu", serif;
            }
            
            .instruction hr{
            height:1px;
            color: #E4E4E4;
            }

            .contact {
                align-self: flex-start;
              }

            .contact .inner{  
               border-radius:4px;
              
               }
            .contact .header{
              color: ${(vouchercolors&&vouchercolors.header_color)?vouchercolors.header_color:"#CF9137"};
              font-size: 13px;
              font-weight: 600;
            }
            .contact strong{
           color: #454545;
            font-size: 10px;
            font-weight: 500;
            text-transform:capitalize;
              }

            .contact p{
            color: #454545;
            font-size: 10px;
            font-weight: 400;
              }
            .contact hr{
            height:1px;
            color: #E4E4E4;
            }

            .fixed-footer {
                position: fixed;
                bottom: 0;
                left: 0;
                width: 100%;
                z-index: 10;
                box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
                background:black;
                border-radius:4px;
              }
              .fixed-footer i{
              color:#CF9137;
              font-size:18px;
              margin:0px 3px 0px 3px;
              }
             
               .fixed-footer .left span{
              color:#CF9137;
              font-size:16px;
              font-weight:500;
              }
              .fixed-footer .middle img{
              height:40px;
              width:40px;
              }
              .fixed-footer .right span{
              color:#CF9137;
              font-size:12px;

              }
          </style>
        </head>
        <body>
          <div class="container-fluid mb-1 bg-white">
            <div class="row align-items-center mb-1 header-container p-0">
              <div class="col-3 text-start pt-0 mt-0">
                <div class="border py-2 px-3 rounded mt-0">
                  <div class='d-flex justify-content-between'>
                    <span class=" text-start">Voucher number</span>
                    <strong class="text-end">78688</strong>
                  </div>
                  <div class='d-flex justify-content-between'>
                    <span class="text-start">Created date</span>
                    <strong class="text-end">${new Date().toLocaleDateString()}</strong>
                  </div>
                </div>
              </div>
              <div class="col-6 text-center pt-0">
                <img src="${profile&&profile.profile_pic}" alt="Agency Logo" class="header-logo mb-2">
                <h4>${profile?.name?.length>30?`${profile?.name?.slice(0,30)}...`:profile?.name}</h4>
                <small class="text-muted pb-0">${profile&&profile?.address?.length>30?`${profile?.address?.slice(0,30)}...`:profile?.address}</small>
                <small class="text-muted py-0">${profile?.phone?.length>25?`${profile?.phone?.slice(0,25)}...`:profile?.phone}</small>
              </div>
              <div class="col-3 text-start border py-2 px-3 rounded mt-0">
               <div class='d-flex justify-content-between'>
               <div>
                <span class="text-muted">Shirka</span><br />
                <strong>ABC</strong>
               </div>
               
               <div>
               <div class='shirka_logo my-auto'>
                <img src="${shiraka_dummy_logo}" alt="" class="header-logo my-auto">
               </div>
               </div>

               </div>
              </div>
            </div>
  
            <div class="row info_row pt-1 pb-2 px-3">
              <div class='col-12 py-0 my-1'>
              
              <div class=" table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                 <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>General Information About Service</strong></th>
                       <th colspan='5'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class="text-center">Adult</th>
                      <th class="text-center">Children</th>
                      <th class="text-center">Infants</th>
                      <th class="text-center">Departure Date</th>
                      <th class="text-center">Arrival Date</th>
                      <th class="text-center">Nights</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class='text-center'>2</td>
                      <td class="text-center">1</td>
                      <td class="text-center">1</td>
                        <td class="text-center">${departure_flight_date}</td>
                        
                        <td class="text-center">${arrival_flight_date}</td>
                     
                      <td class=' text-center'>${duration||"Nill"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
  
              <div class='col-12 py-0 my-1'>
             
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                      <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Departure Flight</strong></th>
                       <th colspan='6'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class="text-center">Airport</th>
                      <th class="text-center">Flight No</th>
                      <th class="text-center">Flight Class</th>
                      <th class="text-center">Dep Date</th>
                      <th class="text-center">Dep Time</th>
                      <th class="text-center">Arrival Date</th>
                      <th class="text-center">Arrival Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class='text-center'>${departure_location ||'Nill'}</td>
                      <td class="text-center">${departure_flight_number||"Nill"}</td>
                      <td class="text-center">${departure_flight_class||"Nill"}</td>
                      <td class="text-center">${departure_flight_date}</td>
                     
                      <td class="text-center">${departure_time||"Nill"}</td>
                       <td class="text-center">${departure_to_flight_date}</td>
                     
                      <td class='text-center'>${departure_to_time||"Nill"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
             
  
              <div class='col-12 py-0 my-1'>
            
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                
                      <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Return Flight</strong></th>
                       <th colspan='6'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class="text-center">Airport</th>
                      <th class="text-center">Flight No</th>
                      <th class="text-center">Flight Class</th>
                      <th class="text-center">Dep Date</th>
                      <th class="text-center">Dep Time</th>
                      <th class="text-center">Arrival Date</th>
                      <th class="text-center">Arrival Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class=' text-center'>${arrival_location||"Nill"}</td>
                      <td class="text-center">${arrival_flight_number||"Nill"}</td>
                      <td class="text-center">${arrival_flight_class||"Nill"}</td>

                      <td class="text-center">${arrival_flight_date}</td>
                     
                      <td class="text-center">${arrival_time}</td>

                       <td class="text-center">${take_off_flight_date}</td>

                     
                      <td class='text-center'>${take_off_time||"Nill"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
            
              
              <div class='col-12 py-0 my-1''>
               ${isHotel ? `
              
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                 <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Accommodation Detail</strong></th>
                       <th colspan='5'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class="text-center">City</th>
                      <th class="text-center">Hotel</th>
                      <th class="text-center">Check in</th>
                      <th class="text-center">Check out</th>
                      <th class="text-center">Room type</th>
                      <th class="text-center">Nights</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${accomodation_details.length>0&&accomodation_details.map(accom => `
                      <tr class='py-0 my-0'>
                        <td class='text-center'>${accom.hotel_city||"Nill"}</td>
                        <td class="text-center">${accom.hotel_name||"Nill"}</td>

                         <td class="text-center">${accom.check_in_date}</td>
                        <td class="text-center">${accom.check_out_date}</td>
                      
                       
                        <td class="text-center">Sharing/Single/Double</td>
                        <td class='text-center'>${accom.hotel_duration||"Nill"}</td>
                      </tr>`).join('')}
                  </tbody>
                </table>
              </div>` : ''}
              </div>
  
             

              <div class='col-12 py-0 my-1'>
              
               <h6 class="mb-1">Transportation Details</h6>
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                 <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Transportation Details</strong></th>
                       <th colspan='2'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class='text-center'>Trasnport</th>
                      <th class='text-center'>Trasnport Services For</th>
                      <th class='text-center'>Ziyarat</th>
                      
                    </tr>
                  </thead>
                  <tbody >
                    <tr>
                      <td class='text-center'>${transport_details||"Nill"}</td>
                      <td class='text-center'>${transport_services_for||"Nill"}</td>
                      <td class='text-center'>${ziyarat||"Nill"}</td>
                     
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>

  
              <div class='col-12 py-0 my-1'>
              
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                 <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Mutamer's (Pilgrims) Details</strong></th>
                       <th colspan='7'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2' >
                    <tr>
                      <th class="text-center">Pilgrim name</th>
                      <th class="text-center">Passport No</th>
                      <th class="text-center">DOB</th>
                      <th class="text-center">Age Group</th>
                      <th class="text-center">Visa no</th>
                      <th class="text-center">Issue date</th>
                      <th class="text-center">Group code</th>
                      <th class="text-center">Mofa Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${members.map(member => `
                      <tr>
                        <td class=' text-center'>${member.name}</td>
                        <td class="text-center">${member.ppNo}</td>

                        <td class="text-center">${member.dob}</td>
                        <td class="text-center">${member.age_group}</td>
                        <td class="text-center">${member.visa_number}</td>

                        <td class="text-center">${member.visa_issue_date}</td>
                      
                        <td class="text-center">YU7856</td>

                         <td class="text-center">${member.mofa_date}</td>
                      </tr>`).join('')}
                  </tbody>
                </table>
              </div>
              </div>
              
           <div class='col-9 mt-1 py-0 instruction ${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'order-2 text-end ':'order-1 text-start '}'>
            <div class='px-2 border inner pt-2 pb-3 '> 
            <h6 class=" ${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'text-end urdu_font mb-3':'text-start english_font mb-2'}">${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'اہم ہدایات':'Instructions'}</h6>
            ${(!instructions || !instructions.content?.trim() || instructions.content.trim() === '<p><br></p>') 
                ? `<p class=' paragraph'>During Hajj or Umrah, pilgrims should first ensure they are in a state of Ihram, which involves wearing specific garments and making the intention to perform the pilgrimage. Upon arrival in Makkah, the first step is to perform Tawaf, circling the Kaaba seven times in a counterclockwise direction. After Tawaf, pilgrims should perform Sa'i, walking seven times between the hills of Safa and Marwah. It's important to stay hydrated and maintain a respectful demeanor throughout the journey. Finally, remember to engage in prayers and reflection, making the most of this spiritual experience.</p>` 
                : ""}
                ${(instructions&&instructions.content?.trim()!==''&&instructions.content.trim() !== '<p><br></p>'&&!instructions.isUrdu)? `<p class='paragraph'>${instructions?.content}</p>` 
                  : ""}
                ${(instructions&&instructions.content?.trim()!==''&&instructions.content.trim() !== '<p><br></p>'&&instructions.isUrdu)? `<h5 class=''>${instructions?.content}</h5>` 
                  : ""}
            
          
            </div>
            
             </div>

           <div class='col-3 mt-1 py-0 contact ${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'order-1 text-end':'order-2 text-start'}'>
           <div class='p-2 border inner'> 
            <h6 class="${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'text-end urdu_font mb-3':'text-start mb-2'}">${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'رابطہ کی تفصیلات':'Contact'}</h6>
          
            ${profile.focal_persons.map(person =>
                  ` 
              <div class='d-flex justify-content-between'>
                <strong>${person.city} / ${person.name}</strong>
                <p>${person.phone}</p>
              </div>
              `).join('')}
           </div>
           
          </div>


            </div>

           <div class="fixed-footer px-2 py-1 text-center">
          <div class='d-flex justify-content-between my-auto'>
          <div class="left my-auto">
          <i class="fa-brands fa-linkedin"></i>
          <i class="fa-brands fa-square-facebook"></i>
          <i class="fa-brands fa-instagram"></i>
          <i class="fa-brands fa-square-x-twitter"></i>
          <i class="fa-brands fa-tiktok"></i>
          <i class="fa-brands fa-youtube"></i>
          <i class="fa-brands fa-pinterest"></i>
          <i class="fa-brands fa-quora"></i>
          <span class='ms-1'>@Gohijaz</span>
          </div>
          <div class="middle my-auto">
          <img src=${logo} alt=''/>
          </div>
          <div class="right my-auto">
          <i class="fa-brands fa-edge"></i> <span> www.gohijaz.com</span>
          <i class="fa-solid fa-phone"></i> <span> +92 000 000 0000</span>
          
          </div>
          </div>
        </div>
            
          </div>
        </body>
      </html>
    `;
    iframe.contentWindow.document.open();
    iframe.contentWindow.document.write(printContentString);
    iframe.contentWindow.document.close();
  

    setTimeout(() => {
      iframe.contentWindow.print();
      document.body.removeChild(iframe); 
    }, 500);

  }
  
  return (
    <div
      className={`${collapsed ? "collapsed mt-5 " : "main mt-5"}`}>
      <div className="container-fluid bg-none my-0 mt-4">
        {/* Packages */}
        {!newPackage &&
          <div className="row px-2 mt-5 pt-4 packages">

            {isAgencyProfile &&
              <div className="col-md-12 data_table p-2 py-auto my-auto header_section">
                <div className="d-flex justify-content-between py-3 px-2">
                  <div className="d-flex left">
                    <div className="btn-group rounded" role="group" aria-label="Basic example">

                      <button type="button" className={`py-2 px-3 rounded-start ${packageStatus === 1 && 'active'}`} onClick={() => { setPackageStatus(1) }}>Active packages</button>

                      <button type="button" className={`py-2 px-3 ${packageStatus === 2 && 'active'}`} onClick={() => { setPackageStatus(2) }}>Pending packages</button>
                      <button type="button" className={`py-2 px-3 rounded-end ${packageStatus === 3 && 'active'}`} onClick={() => { setPackageStatus(3) }}>Inactive packages</button>

                    </div>
                  </div>
                  <div className="right">
                    <button
                      className="add_new_package_btn px-2 my-auto"
                      onClick={handleClickOpenNew}
                    >
                      Create new package
                    </button>

                  </div>
                </div>
              </div>
            }

            <div className="col-md-12 data_table p-2 pt-1 pb-3 mt-3 my-auto mx-auto packages_section">
              <div className="d-flex justify-content-between mt-2 px-2 mb-3 info_header">
                <div className="left my-auto">
                  <h4 className=" my-auto">{packageStatus === 1 ? "Active" : packageStatus === 2 ? "Pending" : "Inactive"} pakages</h4>
                </div>
                <div className="right my-auto">
                  <button className='filter_btn p-0 my-auto'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z" />
                    </svg>
                  </button>
                </div>
              </div>
              <hr className="mb-2" />
              <div className="row mx-1">
                {filteredPackages && filteredPackages.map((data, index) => (
                  <div key={index} className="col-md-12 packages_card p-2 my-2">
                    <div className="d-flex justify-content-between package_header pt-0 px-1 mb-2">
                      <div className="left my-auto">
                        <h5 className="my-auto">{data.package_title}</h5>
                      </div>
                      <div className="right d-flex my-auto">
                        <div className="btn-group" role="group" aria-label="Basic outlined example">
                          <button onClick={() => handleEditPackage(data)}><svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.1959 9.49152C18.4527 9.85159 18.5811 10.0316 18.5811 10.2981C18.5811 10.5646 18.4527 10.7447 18.1959 11.1047C17.0422 12.7226 14.0956 16.2103 10.1352 16.2103C6.17466 16.2103 3.22814 12.7226 2.07438 11.1047C1.8176 10.7447 1.68921 10.5646 1.68921 10.2981C1.68921 10.0316 1.8176 9.85159 2.07438 9.49152C3.22814 7.87366 6.17466 4.38596 10.1352 4.38596C14.0956 4.38596 17.0422 7.87366 18.1959 9.49152Z" stroke="#6D76A1" stroke-width="1.52027" />
                            <path d="M12.6689 10.2981C12.6689 8.89872 11.5345 7.76431 10.1351 7.76431C8.73573 7.76431 7.60132 8.89872 7.60132 10.2981C7.60132 11.6975 8.73573 12.8319 10.1351 12.8319C11.5345 12.8319 12.6689 11.6975 12.6689 10.2981Z" stroke="#6D76A1" stroke-width="1.52027" />
                          </svg>
                          </button>
                          {isAgencyProfile &&
                            <>
                              <button onClick={() => handleEditPackage(data)}><svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.29056 2.1416H7.60137C3.3784 2.1416 1.68921 3.83079 1.68921 8.05376V13.1213C1.68921 17.3443 3.3784 19.0335 7.60137 19.0335H12.6689C16.8919 19.0335 18.5811 17.3443 18.5811 13.1213V11.4321" stroke="#6D76A1" stroke-width="1.52027" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.5472 3.00336L6.89176 9.65877C6.63838 9.91214 6.385 10.4105 6.33432 10.7736L5.97115 13.3159C5.83601 14.2365 6.48635 14.8784 7.40696 14.7517L9.94919 14.3885C10.3039 14.3378 10.8022 14.0844 11.0641 13.8311L17.7195 7.17566C18.8681 6.02701 19.4086 4.69255 17.7195 3.00336C16.0303 1.31417 14.6958 1.85471 13.5472 3.00336Z" stroke="#6D76A1" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12.593 3.95801C13.1589 5.97659 14.7383 7.55598 16.7653 8.13031" stroke="#6D76A1" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                              </button>
                              <button onClick={() => deletePackage(data._id)}><svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.9018 5.09814L16.3784 13.5653C16.2447 15.7286 16.1778 16.8102 15.6356 17.5879C15.3675 17.9724 15.0223 18.2969 14.622 18.5407C13.8124 19.034 12.7287 19.034 10.5612 19.034C8.39095 19.034 7.3058 19.034 6.49562 18.5398C6.09507 18.2955 5.7498 17.9704 5.4818 17.5853C4.93973 16.8064 4.87434 15.7232 4.74356 13.5569L4.23291 5.09814" stroke="#6D76A1" stroke-width="1.52027" stroke-linecap="round" />
                                <path d="M2.96606 5.09768H18.1688M13.9929 5.09768L13.4163 3.90826C13.0333 3.11817 12.8418 2.72312 12.5114 2.47674C12.4382 2.42209 12.3606 2.37348 12.2794 2.33138C11.9136 2.1416 11.4746 2.1416 10.5966 2.1416C9.6965 2.1416 9.24645 2.1416 8.87458 2.33934C8.79216 2.38316 8.71352 2.43374 8.63945 2.49056C8.30529 2.74692 8.11862 3.15643 7.74529 3.97543L7.23374 5.09768" stroke="#6D76A1" stroke-width="1.52027" stroke-linecap="round" />
                                <path d="M8.45605 14.3882L8.45605 9.32062" stroke="#6D76A1" stroke-width="1.52027" stroke-linecap="round" />
                                <path d="M12.6787 14.3884L12.6787 9.3208" stroke="#6D76A1" stroke-width="1.52027" stroke-linecap="round" />
                              </svg>
                              </button>

                              {packageStatus !== 2 &&

                                <button onClick={() => duplicatePackageStatus(data._id)}>
                                  <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.3783 11.348V14.8953C14.3783 17.8514 13.1958 19.0338 10.2398 19.0338H6.69247C3.73639 19.0338 2.55396 17.8514 2.55396 14.8953V11.348C2.55396 8.39191 3.73639 7.20947 6.69247 7.20947H10.2398C13.1958 7.20947 14.3783 8.39191 14.3783 11.348Z" stroke="#6D76A1" stroke-width="1.52027" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.4459 6.28012V9.82741C19.4459 12.7835 18.2635 13.9659 15.3074 13.9659H14.3783V11.3477C14.3783 8.3916 13.1959 7.20917 10.2398 7.20917H7.62158V6.28012C7.62158 3.32403 8.80401 2.1416 11.7601 2.1416H15.3074C18.2635 2.1416 19.4459 3.32403 19.4459 6.28012Z" stroke="#6D76A1" stroke-width="1.52027" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                </button>
                              }
                              {packageStatus !== 2 &&
                                <label className="switch my-auto" >
                                  <input type="checkbox" onClick={() => updatePackageStatus(data._id, 'update')} checked={data.isActive}
                                  />
                                  <span className="slider round"></span>
                                </label>
                              }

                              {packageStatus === 2 &&
                                <button className="publish_btn" onClick={() => updatePackageStatus(data._id, 'publish')} >
                                  Publish
                                </button>
                              }
                            </>
                          }

                        </div>
                      </div>
                    </div>
                    <hr className="mb-0 pb-0 ms-3" />

                    <div className="d-flex justify-content-between package_header px-0 mb-2 mt-0 ">
                      <div className="left my-auto d-flex">
                        <div className="image">
                          <img src={data.cover_image} alt="" />
                        </div>
                        <ul className="ps-1 my-auto">

                          {isAgencyProfile &&
                            <>
                              <li className="my-1"><span>
                                <svg className="me-2" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M8 16.6753H15.2632C19.7508 16.6753 20.4333 13.8561 21.261 9.74437C21.4998 8.55841 21.6192 7.96542 21.3321 7.57036C21.045 7.17529 20.4947 7.17529 19.3941 7.17529H6" stroke="#6D76A1" stroke-width="1.5" stroke-linecap="round" />
                                  <path d="M8 16.6753L5.37873 4.19022C5.15615 3.29989 4.35618 2.67529 3.43845 2.67529H2.5" stroke="#6D76A1" stroke-width="1.5" stroke-linecap="round" />
                                  <path d="M8.88 16.6753H8.46857C7.10522 16.6753 6 17.8266 6 19.2467C6 19.4834 6.1842 19.6753 6.41143 19.6753H17.5" stroke="#6D76A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <circle cx="10.5" cy="21.1753" r="1.5" stroke="#6D76A1" stroke-width="1.5" />
                                  <circle cx="17.5" cy="21.1753" r="1.5" stroke="#6D76A1" stroke-width="1.5" />
                                </svg>Sold:
                              </span>  {data.sold}
                              </li>
                              <li className="my-1"><span>
                                <svg className="me-2" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M18 12.1752C18 12.1752 13.5811 6.17531 12 6.17529C10.4188 6.17528 6 12.1753 6 12.1753" stroke="#6D76A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M18 19.1752C18 19.1752 13.5811 13.1753 12 13.1753C10.4188 13.1753 6 19.1753 6 19.1753" stroke="#6D76A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>Earnings:
                              </span>  {data.totalEarnings?.toLocaleString()}
                              </li>
                            </>
                          }

                          <li className="my-1"><span>
                            <svg className="me-2" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="12" cy="12.6753" r="10" stroke="#6D76A1" stroke-width="1.5" />
                              <path d="M12.75 7.67529C12.75 7.26108 12.4142 6.92529 12 6.92529C11.5858 6.92529 11.25 7.26108 11.25 7.67529H12.75ZM14.0303 13.645C13.7374 13.3521 13.2626 13.3521 12.9697 13.645C12.6768 13.9379 12.6768 14.4127 12.9697 14.7056L14.0303 13.645ZM14.4697 16.2056C14.7626 16.4985 15.2374 16.4985 15.5303 16.2056C15.8232 15.9127 15.8232 15.4379 15.5303 15.145L14.4697 16.2056ZM11.25 7.67529V11.1753H12.75V7.67529H11.25ZM12.9697 14.7056L14.4697 16.2056L15.5303 15.145L14.0303 13.645L12.9697 14.7056ZM12.75 12.6753C12.75 13.0895 12.4142 13.4253 12 13.4253V14.9253C13.2426 14.9253 14.25 13.9179 14.25 12.6753H12.75ZM12 13.4253C11.5858 13.4253 11.25 13.0895 11.25 12.6753H9.75C9.75 13.9179 10.7574 14.9253 12 14.9253V13.4253ZM11.25 12.6753C11.25 12.2611 11.5858 11.9253 12 11.9253V10.4253C10.7574 10.4253 9.75 11.4327 9.75 12.6753H11.25ZM12 11.9253C12.4142 11.9253 12.75 12.2611 12.75 12.6753H14.25C14.25 11.4327 13.2426 10.4253 12 10.4253V11.9253Z" fill="#6D76A1" />
                            </svg>Duration:
                            {data.package_header.trim().toLowerCase().includes('umrah') ? `${data.duration} Days/${Number(data.duration) - 1} Nights` : `${data.duration}`}
                          </span>
                          </li>

                        </ul>

                        <ul className="ps-1 my-auto ms-2 border-start">

                      {isAgencyProfile &&
                        <>
                          <li className="my-1"><span>
                          <svg className="me-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                              </svg>Searches:
                          </span> {data.searches?.reduce((total, search) => total + (search.count || 0), 0)}
                          </li>
                          <li className="my-1"><span>
                          <svg className="me-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
                          </svg>Clicks:
                          </span> {data.clicks?.reduce((total, click) => total + (click.count || 0), 0)}
                          </li>
                        </>
                      }

                      </ul>
                      </div>
                      <div className="right d-flex mt-auto price">
                        {/* <h6> {data.totalPrice?.toLocaleString()}</h6> */}
                        {/* <span>{data.currency}</span> */}
                      </div>
                    </div>

                  </div>
                ))}

              </div>
            </div>
          </div>
        }
        {/* New Umrah Package section   Old Design*/}
        {(!isNewDesign&&newPackage && package_header.trim().toLowerCase() === 'umrah package') &&
          <div className="row mt-5 pt-4">
            <form onSubmit={editedPackageId ? updatePackage : handleFormSubmit}>
              <div className="col-md-12 data_table p-2 pt-1 pb-3 my-auto new_package">
                {/* Step Content */}
                <div className="card p-4 border-0 ">

                  <div className="row ">
                    <div className="d-flex justify-content-between px-1 mb-3 info_header">
                      <div className="left">
                      <h4 className="my-auto">{editedPackageId ? "Edit the" : "Enter the"} package details</h4>
                      </div>
                      <div className="right">
                        
                      <button className="px-3 py-2 save_btn my-auto mx-1" type='button' disabled={loading1} onClick={()=>VoucherPreview()}><i className="fa-solid fa-eye me-2"></i>Preview</button>
                        {(editedPackageId && isAgencyProfile) && <button className="px-3 py-2 save_btn my-auto" type='submit' disabled={loading1}>{loading1 ? "Saving" : "Save"}</button>}
                      </div>
                    </div>
                    <hr />
                  </div>
                  <div className="row my-2">

                    <div className="col-lg-3 col-md-6 col-12 px-1 my-2">
                      <label className="required">
                        Package Name
                      </label>
                      {/* <TextField fullWidth value={package_title}  onChange={(e) => setpackage_title(e.target.value)} label="Package Name" className='text-field'/> */}
                      <input type="text" value={package_title} onChange={(e) => setpackage_title(e.target.value)}
                        // placeholder="Package name "
                        required readOnly={!isAgencyProfile} />
                    </div>
                    <div className="col-lg-3 col-md-6 col-12 px-1 my-2">
                      <label htmlFor="">
                        Package Code/ID
                      </label>
                      {/* <TextField fullWidth value={package_code} onChange={(e) => setpackage_code(e.target.value)} label="Package Code/ID" className='text-field'/> */}

                      <input type="text" value={package_code} onChange={(e) => setpackage_code(e.target.value)}
                        // placeholder="Package Code/ID"
                        readOnly={!isAgencyProfile}
                      />

                    </div>
                    <div className="col-lg-3 col-md-6 col-12 px-1 my-2">
                      <label htmlFor="" className='required'>
                        Available Slots
                      </label>
                      {/* <TextField fullWidth value={package_code} onChange={(e) => setpackage_code(e.target.value)} label="Package Code/ID" className='text-field'/> */}

                      <input type="number" value={total_slots} onChange={(e) => settotal_slots(e.target.value)} required readOnly={!isAgencyProfile} />

                    </div>
                    <div className="col-lg-3 col-md-6 col-12 px-1 my-2">
                      <label className="required">
                        Duration (In days)
                      </label>
                      {/* <TextField fullWidth value={duration} onChange={(e) => setduration(e.target.value)} label="Duration (In Days)" className='text-field'/> */}

                      <input type="number" min='0' value={duration} onChange={(e) => setduration(e.target.value)}
                        // placeholder='Duration (In Days)'
                        required readOnly={!isAgencyProfile} />
                    </div>
                    <div className="col-lg-9 col-md-12 col-12 px-1 my-2">
                      <label>
                        Package description
                      </label>
                      <textarea name="" id=""
                        placeholder='Add description'
                        value={package_description} onChange={(e) => setpackage_description(e.target.value)} readOnly={!isAgencyProfile}></textarea>
                    </div>
                    <div className="col-lg-3 col-md-12 col-12 px-1 my-2">
                      <label htmlFor="file-upload" >Add Cover Image</label>
                      {!cover_image ? (
                        <label htmlFor="file-upload" className="custom-file-upload d-flex flex-column align-items-center">
                          <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">

                          </svg>
                          <h6 className="mt-1">
                            Upload Package Image
                            <p className="text-muted">or drag and drop SVG, PNG, JPG, or GIF (max. 800x400px)</p>
                          </h6>
                          <input
                            id="file-upload"
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={handleImage}
                            readOnly={!isAgencyProfile}
                          />
                        </label>
                      ) : (
                        <div className="selected-image">
                          <label htmlFor="selected-file-upload">
                            <img
                              src={cover_image}
                              alt="Cover"
                              style={{ cursor: 'pointer' }}
                            />
                          </label>
                          <input
                            id="selected-file-upload"
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={handleImage}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <hr />

                  <div className="row my-2">
                    <h5 className="mb-2">Departure Flight</h5>
                    <div className="col-md-4 px-1 my-2">
                      <label >
                        Airline Name
                      </label>
                      {/* <Select
                      options={airlineOptions}
                      isDisabled={!isAgencyProfile}
                      value={airlineOptions.find((option) => option.value === departure_airline_id) || null}
                      onChange={handleSelectChange}
                      placeholder="Select or Search Airline"
                      isClearable
                    /> */}
                      <select name="" id="" value={departure_airline_id} onChange={(e) => {
                        setdeparture_airline_name('')
                        setdeparture_airline_id('');
                        const value = e.target.value
                        setdeparture_airline_id(e.target.value);
                        setarrival_airline_id(e.target.value);
                        const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                        if (findId) {
                          setdeparture_airline_name(findId.name)
                          setarrival_airline_name(findId.name)
                        }
                      }}  readOnly={!isAgencyProfile}>

                        <option value="">Select</option>
                        {defaultconfigurations && defaultconfigurations.filter(data => data.type.trim().toLowerCase() === 'airlines').map((data, index) => (
                          <option value={data._id} key={data._id}>{data.name} - {data.iata_code}</option>
                        ))}

                        {configurations && configurations.filter(data => data.type.trim().toLowerCase() === 'airlines').map((data, index) => (
                          <option value={data.title} key={data._id}>{data.title}</option>
                        ))}

                       </select> 
                    </div>

                    <div className="col-md-4 px-1 my-2">
                      <label>
                        Flight Class
                      </label>

                      {/* <div className="custom-flight-class-selector position-relative">
      <div
        className={`form-control mb-3 text-start ${
          !isAgencyProfile ? "readonly" : ""
        }`}
        onClick={() => isAgencyProfile && setIsDropdownOpen(!isDropdownOpen)}
        style={{ cursor: isAgencyProfile ? "pointer" : "not-allowed" }}
      >
        {departure_flight_class || "Select Flight Class"}
      </div>

      
      {isDropdownOpen && (
        <div className="dropdown-menu show w-100 py-0 mb-0" style={{ zIndex: 10 }}>
        
          <input
            type="text"
            placeholder="Search flight class..."
            className="form-control mt-0"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
          <ul className="list-group mt-0 pt-0">
            {filteredFlightClasses?.length > 0 ? (
              filteredFlightClasses.map((data) => (
                <li
                  key={data._id}
                  className="list-group-item list-group-item-action mt-0"
                  onClick={() => handleFlightClassSelection(data.flight_class)}
                  style={{ cursor: "pointer" }}
                >
                  {data.flight_class}
                </li>
              ))
            ) : (
              <li className="list-group-item">No flight classes found</li>
            )}
          </ul>
        </div>
      )}
    </div> */}
                      <select name="" id="" value={departure_flight_class} onChange={(e) => {setdeparture_flight_class(e.target.value);setarrival_flight_class(e.target.value)}} readOnly={!isAgencyProfile}>
                        <option value="">Select</option>

                        {defaultconfigurations && defaultconfigurations.filter(data => data.type.trim().toLowerCase() === 'flight class').map((data, index) => (
                          <option value={data.flight_class} key={data._id}>{data.flight_class}</option>
                        ))}
                        

                      </select>
                    </div>

                    <div className="col-md-4 px-1 my-2">
                      <label htmlFor="">
                        Flight Number
                      </label>
                      {/* <TextField fullWidth value={departure_flight_number} onChange={(e) => setdeparture_flight_number(e.target.value)} label="Flight Number (Optional)" className='text-field'/> */}
                      <input type="text"
                        //  placeholder="Flight Number (Optional)"
                        value={departure_flight_number} onChange={(e) => setdeparture_flight_number(e.target.value)} readOnly={!isAgencyProfile} />
                    </div>

                    <div className="col-xl-4 col-md-6 px-1 my-2">
                      <div className="d-flex justify-content-between ">
                        <div className="w-50 text-start">
                          <label >Departure City</label>
                        </div>
                        <div className="w-50 text-start">
                          <label >Arrival City</label>
                        </div>
                      </div>
                      <div className="input-group half_width">
                        <select
                          name=""
                          id=""
                          className="border-end"
                          value={departure_location_id}
                          onChange={(e) => {
                            setdeparture_location('')
                            setdeparture_location_id('');
                            const value = e.target.value
                            setdeparture_location_id(e.target.value);
                            const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                            if (findId) {
                              setdeparture_location(findId.airport_name)
                            }
                          }}
                          
                          readOnly={!isAgencyProfile}
                        >
                          <option value="">Select</option>

                          {defaultconfigurations &&
                            defaultconfigurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports' &&data.country.toLowerCase().includes('pakistan'))
                              .map((data, index) => (
                                <option value={data._id} key={data._id}>
                                  {data.airport_name} - {data.iata_code}
                                </option>
                              ))}

                          {/* {configurations &&
                            configurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports')
                              .map((data, index) => (
                                <option value={data.title} key={data._id}>
                                  {data.title}
                                </option>
                              ))} */}
                        </select>
                        <select
                          name=""
                          id=""
                          className="border-start"
                          value={departure_to_location_id}

                          onChange={(e) => {
                            setdeparture_to_location('')
                            setdeparture_to_location_id('');
                            const value = e.target.value
                            setdeparture_to_location_id(e.target.value);
                            const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                            if (findId) {
                              setdeparture_to_location(findId.airport_name)
                            }
                          }}
                           readOnly={!isAgencyProfile}
                        >

                          <option value="">Select</option>
                          {defaultconfigurations &&
                            defaultconfigurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports'&&data.country.toLowerCase().includes('saudi'))
                              .map((data, index) => (
                                <option value={data._id} key={data._id}>
                                  {data.airport_name} - {data.iata_code}
                                </option>
                              ))}

                          {/* {configurations &&
                            configurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports')
                              .map((data, index) => (
                                <option value={data.title} key={data._id}>
                                  {data.title}
                                </option>
                              ))} */}

                          {/* <option value="Jeddah">Jeddah</option>
                          <option value="Madinah">Madinah</option>
                          <option value="Riyadh">Riyadh</option>
                          <option value="Dammam">Dammam</option>
                          <option value="Taif">Taif</option>
                          <option value="Yanbu">Yanbu</option>
                          <option value="Al-Ahsa">Al-Ahsa</option> */}

                        </select>
                      </div>
                    </div>

                    <div className="col-xl-4 col-md-6 px-1 my-2">
                      <div className="d-flex justify-content-between ">
                        <div className="w-50 text-start">
                          <label >Departure Date</label>
                        </div>
                        <div className="w-50 text-start">
                          <label >Departure Time </label>
                        </div>
                      </div>
                      <div className="input-group half_width">
                      <DatePicker  className='input border-end' disabledDate={(current) =>current && current.isBefore(dayjs(new Date().toISOString().split("T")[0], 'DD/MM/YYYY'))} value={departure_flight_date ? dayjs(departure_flight_date, 'DD/MM/YYYY') : null} placeholder={departure_flight_date||"Departure Date"} onChange={(date, dateString) => setdeparture_flight_date(dateString)} readOnly={!isAgencyProfile} format="DD/MM/YYYY"/>
                        {/* <input
                          type="text"
                          placeholder="Departure date"
                          onFocus={(e) => (e.target.type = "date")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}

                          className='border-end' min={new Date().toISOString().split("T")[0]} value={departure_flight_date} onChange={(e) => setdeparture_flight_date(e.target.value)} readOnly={!isAgencyProfile} /> */}

                               <TimePicker
                            className="input border-start"
                            placeholder={departure_time}
                            
                                      onChange={(time,timeString) => setdeparture_time(timeString)}
                                      defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                      format="HH:mm" // To ensure 24-hour format if not already set by default
                                  />
                        {/* <input
                          type="text"
                          placeholder="Departure time"
                          onFocus={(e) => (e.target.type = "time")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='border-start' value={departure_time} onChange={(e) => setdeparture_time(e.target.value)} readOnly={!isAgencyProfile} /> */}
                         
                          
                      </div>

                    </div>
                    <div className="col-xl-4 col-md-6 px-1 my-2">
                      <div className="d-flex justify-content-between ">
                        <div className="w-50 text-start">
                          <label >Arrival Date</label>
                        </div>
                        <div className="w-50 text-start">
                          <label>Arrival Time</label>
                        </div>
                      </div>
                      <div className="input-group half_width">
                      <DatePicker  className='input border-end' disabledDate={(current) =>current && current.isBefore(dayjs(departure_flight_date,'DD/MM/YYYY'))} value={departure_to_flight_date ? dayjs(departure_to_flight_date, 'DD/MM/YYYY') : null} placeholder={departure_to_flight_date||"Arrival Date"} onChange={(date, dateString) => setdeparture_to_flight_date(dateString)} readOnly={!isAgencyProfile} format="DD/MM/YYYY"/>

                        {/* <input
                          type="text"
                          placeholder="Arrival date"
                          onFocus={(e) => (e.target.type = "date")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='border-end' min={departure_flight_date} value={departure_to_flight_date} onChange={(e) => setdeparture_to_flight_date(e.target.value)} readOnly={!isAgencyProfile} /> */}
                           <TimePicker
                            className="input border-start"
                            placeholder={departure_to_time}

                                      onChange={(time,timeString) => setdeparture_to_time(timeString)}
                                      defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                      format="HH:mm" // To ensure 24-hour format if not already set by default
                                  />
                        {/* <input
                          type="text"
                          placeholder="Arrival time"
                          onFocus={(e) => (e.target.type = "time")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='border-start' value={departure_to_time} onChange={(e) => setdeparture_to_time(e.target.value)} readOnly={!isAgencyProfile} /> */}
                      </div>

                    </div>

                  </div>

                  <div className="row my-2">
                    <h5 className="mb-2">Return Flight</h5>
                    <div className="col-md-4 px-1 my-2">
                      <label>
                        Airline Name
                      </label>
                      <select name="" id="" value={arrival_airline_id}
                        onChange={(e) => {
                          setarrival_airline_name('')
                          setarrival_airline_id('');
                          const value = e.target.value
                          setarrival_airline_id(e.target.value);
                          const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                          if (findId) {
                            setarrival_airline_name(findId.name)
                            
                          }
                        }}
                         readOnly={!isAgencyProfile}>
                        <option value="">Select</option>
                        {defaultconfigurations && defaultconfigurations.filter(data => data.type.trim().toLowerCase() === 'airlines').map((data, index) => (
                          <option value={data._id} key={data._id}>{data.name} - {data.iata_code}</option>
                        ))}

                        {/* {configurations && configurations.filter(data => data.type.trim().toLowerCase() === 'airlines').map((data, index) => (
                          <option value={data.title} key={data._id}>{data.title}</option>
                        ))} */}

                      </select>
                    </div>
                    <div className="col-md-4 px-1 my-2">
                      <label>
                        Flight Class
                      </label>
                      <select name="" id="" value={arrival_flight_class} onChange={(e) => setarrival_flight_class(e.target.value)} readOnly={!isAgencyProfile}>

                        <option value="">Select</option>

                        {defaultconfigurations && defaultconfigurations.filter(data => data.type.trim().toLowerCase() === 'flight class').map((data, index) => (
                          <option value={data.flight_class} key={data._id}>{data.flight_class}</option>
                        ))}
                        {/* {configurations && configurations.filter(data => data.type.trim().toLowerCase() === 'flight class').map((data, index) => (
                          <option value={data.title} key={data._id}>{data.title}</option>
                        ))} */}

                      </select>
                    </div>
                    <div className="col-md-4 px-1 my-2">
                      <label htmlFor="">
                        Flight Number
                      </label>
                      <input type="text"
                        // placeholder="Flight Number (Optional)" 
                        value={arrival_flight_number} onChange={(e) => setarrival_flight_number(e.target.value)} readOnly={!isAgencyProfile} />
                    </div>

                    <div className="col-xl-4 col-md-6 px-1 my-2">
                      <div className="d-flex justify-content-between ">
                        <div className="w-50 text-start">
                          <label >Departure City</label>
                        </div>
                        <div className="w-50 text-start">
                          <label >Arrival City</label>
                        </div>
                      </div>
                      <div className="input-group half_width">

                        <select name="" id="" className='border-end' value={arrival_location_id}
                          onChange={(e) => {
                            setarrival_location('')
                            setarrival_location_id('');
                            const value = e.target.value
                            setarrival_location_id(e.target.value);
                            const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                            if (findId) {
                              setarrival_location(findId.airport_name)
                            }
                          }}
                           readOnly={!isAgencyProfile}>
                          <option value="">Select</option>
                          {defaultconfigurations &&
                            defaultconfigurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports'&&data.country.toLowerCase().includes('saudi'))
                              .map((data, index) => (
                                <option value={data._id} key={data._id}>
                                  {data.airport_name} - {data.iata_code}
                                </option>
                              ))}

                          {/* {configurations &&
                            configurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports')
                              .map((data, index) => (
                                <option value={data.title} key={data._id}>
                                  {data.title}
                                </option>
                              ))} */}
                          {/*                               
                          <option value="Jeddah">Jeddah</option>
                          <option value="Madinah">Madinah</option>
                          <option value="Riyadh">Riyadh</option>
                          <option value="Dammam">Dammam</option>
                          <option value="Taif">Taif</option>
                          <option value="Yanbu">Yanbu</option>
                          <option value="Al-Ahsa">Al-Ahsa</option> */}



                        </select>
                        <select name="" id="" className='border-start' value={take_off_location_id}
                          onChange={(e) => {
                            settake_off_location('')
                            settake_off_location_id('');
                            const value = e.target.value
                            settake_off_location_id(e.target.value);
                            const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                            if (findId) {
                              settake_off_location(findId.airport_name)
                            }
                          }}
                           readOnly={!isAgencyProfile}>
                          <option value="">Select</option>
                          {defaultconfigurations &&
                            defaultconfigurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports'&&data.country.toLowerCase().includes('pakistan'))
                              .map((data, index) => (
                                <option value={data._id} key={data._id}>
                                  {data.airport_name} - {data.iata_code}
                                </option>
                              ))}

                          {/* {configurations &&
                            configurations
                              .filter((data) => data.type.trim().toLowerCase() === 'saudi')
                              .map((data, index) => (
                                <option value={data.title} key={data._id}>
                                  {data.title}
                                </option>
                              ))} */}

                        </select>
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-6 px-1 my-2">
                      <div className="d-flex justify-content-between ">
                        <div className="w-50 text-start">
                          <label >Departure Date</label>
                        </div>
                        <div className="w-50 text-start">
                          <label>Departure Time</label>
                        </div>
                      </div>
                      <div className="input-group half_width">
                      <DatePicker  className='input border-end' value={arrival_flight_date ? dayjs(arrival_flight_date, 'DD/MM/YYYY') : null} disabledDate={(current) =>current && current.isBefore(dayjs(departure_flight_date, 'DD/MM/YYYY'))} placeholder={arrival_flight_date||"Departure Date"} onChange={(date, dateString) => setarrival_flight_date(dateString)} readOnly={!isAgencyProfile} format="DD/MM/YYYY"/>

                        {/* <input
                          type="text"
                          placeholder="Departure date"
                          onFocus={(e) => (e.target.type = "date")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='border-end' min={departure_flight_date} value={arrival_flight_date} onChange={(e) => {setarrival_flight_date(e.target.value);settake_off_flight_date(e.target.value)}} readOnly={!isAgencyProfile} /> */}

                           <TimePicker
                            className="input border-start"
                            placeholder={arrival_time}

                                      onChange={(time,timeString) => setarrival_time(timeString)}
                                      defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                      format="HH:mm" // To ensure 24-hour format if not already set by default
                                  />
                        {/* <input
                          type="text"
                          placeholder="Departure time"
                          onFocus={(e) => (e.target.type = "time")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='border-start' value={arrival_time} onChange={(e) => setarrival_time(e.target.value)} readOnly={!isAgencyProfile} /> */}
                      </div>

                    </div>
                    <div className="col-xl-4 col-md-6 px-1 my-2">
                      <div className="d-flex justify-content-between ">
                        <div className="w-50 text-start">
                          <label >Arrival Date</label>
                        </div>
                        <div className="w-50 text-start">
                          <label >Arrival Time</label>
                        </div>
                      </div>
                      <div className="input-group half_width">
                      <DatePicker  className='input border-end'  value={take_off_flight_date ? dayjs(take_off_flight_date, 'DD/MM/YYYY') : null} disabledDate={(current) =>current && current.isBefore(dayjs(departure_flight_date, 'DD/MM/YYYY'))} placeholder={take_off_flight_date||"Arrival Date"} onChange={(date, dateString) => settake_off_flight_date(dateString)} readOnly={!isAgencyProfile} format="DD/MM/YYYY"/>
                        {/* <input
                          type="text"
                          placeholder="Arrival date"
                          onFocus={(e) => (e.target.type = "date")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='border-end' min={arrival_flight_date} value={take_off_flight_date} onChange={(e) => settake_off_flight_date(e.target.value)} readOnly={!isAgencyProfile} /> */}

                          <TimePicker
                            className="input border-start"
                            placeholder={take_off_time}

                                      onChange={(time,timeString) => settake_off_time(timeString)}
                                      defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                      format="HH:mm" // To ensure 24-hour format if not already set by default
                                  />
                        {/* <input
                          type="text"
                          placeholder="Arrival time"
                          onFocus={(e) => (e.target.type = "time")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='border-start' value={take_off_time} onChange={(e) => settake_off_time(e.target.value)} readOnly={!isAgencyProfile} /> */}
                      </div>

                    </div>

                  </div>
                  <hr />


                  <div className="row my-2">
                    <h5 className="mb-2">Add Hotel Details</h5>
                    {/* <div className="col-md-12">
                      <Link
                        disabled={!isAgencyProfile}
                        onClick={() => {
                          setIsHotel(true);
                          if (!editedPackageId) {
                            setadults_price('');
                            setadults_currency('PKR');
                            setchilds_price('');
                            setchilds_currency('PKR');
                            setinfant_price('');
                            setinfant_currency('PKR');

                          }
                        }}
                        className="radio_btn btn mt-2 mx-1"
                        style={{
                          background: isHotel ? 'var(--primary)' : undefined,
                          color: isHotel ? 'white' : undefined,
                          border: isHotel ? '1px solid var(--primary)' : undefined,
                        }}
                      >
                        <Radio
                          size="small"
                          checked={isHotel}
                          name="radio-buttons"
                          className="me-auto"
                          style={{
                            padding: "3px",
                            color: isHotel ? "white" : "#667085", // Fill radio color when active
                          }}
                          inputProps={{ 'aria-label': true }}
                        />
                        With Hotel
                      </Link>
                      <Link
                        disabled={!isAgencyProfile}
                        onClick={() => {
                          setIsHotel(false); if (!editedPackageId) {
                            setaccomodation_details([
                              {
                                hotel_duration: '',
                                hotel_city: 'makkah',
                                hotel_name: '',
                                hotel_id: '',
                                check_in_date: '',
                                check_out_date: ''
                              },
                              {
                                hotel_duration: '',
                                hotel_city: 'madinah',
                                hotel_name: '',
                                hotel_id: '',
                                check_in_date: '',
                                check_out_date: ''
                              },
                              {
                                hotel_duration: '',
                                hotel_city: 'makkah',
                                hotel_name: '',
                                hotel_id: '',
                                check_in_date: '',
                                check_out_date: ''
                              }
                            ]);
                            setpricing([{ room_type: '', first_price: { price: 0, currency: 'PKR' }, second_price: { price: 0, currency: 'PKR' }, third_price: { price: 0, currency: 'PKR' }, }])

                          }

                        }} className="radio_btn btn mt-2 mx-1" style={!isHotel ? { background: 'var(--primary)', color: 'white', border: '1px solid var(--primary)' } : {}}>
                        <Radio
                          size="small"
                          checked={!isHotel}
                          name="radio-buttons"
                          className="me-auto"
                          style={{
                            padding: "3px",
                            color: !isHotel ? "white" : "#667085", // Fill radio color when active
                          }}
                          inputProps={{ 'aria-label': false }}
                        />
                        Without Hotel
                      </Link>
                    </div> */}
                    {isHotel &&
                      <>
                        {accomodation_details.map((row, index) => (
                          <div key={index} className="row my-1 align-items-center">

                            <div className="col-md-2 px-1 my-1">
                              <label >Hotel City</label>
                              <select name="" id="" value={row.hotel_city}
                                onChange={(e) => {
                                  handleHotelInputChange(index, 'hotel_city', e.target.value);
                                }
                                } readOnly={!isAgencyProfile}>
                                <option value="">Select</option>
                                <option value="makkah">MAKKAH</option>
                                <option value="madinah">MADINAH</option>
                              </select>

                            </div>
                            <div className="col-xl-3 col-md-6 px-1 my-1">
                              <label >Hotel Name</label>
                              <select name="" id="" value={row.hotel_name} onChange={(e) => {
                                handleHotelInputChange(index, 'hotel_name', e.target.value)

                              }}  readOnly={!isAgencyProfile}>
                                <option value="">Select</option>
                                {configurations && configurations.filter(data => data.type.trim().toLowerCase() === 'hotels' && data.location.trim().toLowerCase() === row.hotel_city.trim().toLowerCase()).map((data, index) => (
                                  <option value={data.title} key={data._id}>{data.title}</option>
                                ))}
                                 {defaultconfigurations && defaultconfigurations.filter(data => data.type.trim().toLowerCase() === 'hotels').map((data, index) => (
                                  <option value={data.name} key={data._id}>{data.name}</option>
                                ))}
                              </select>

                            </div>


                            {/* Hotel Duration */}
                            <div className="col-xl-3 col-md-6 px-1 my-1">
                              <label >Duration (In Days)</label>
                              <input
                                type="text"

                                disabled={!duration}
                                value={row.hotel_duration}
                                onChange={(e) =>
                                  handleHotelInputChange(index, 'hotel_duration', e.target.value)
                                }
                                readOnly={!isAgencyProfile}
                              />
                            </div>

                            <div className="col-xl-3 col-md-6 px-1 my-1">
                              <div className="d-flex justify-content-between ">
                                <div className="w-50 text-start">
                                  <label >Check In</label>
                                </div>
                                <div className="w-50 text-start">
                                  <label >Check Out</label>
                                </div>
                              </div>
                              <div className="input-group half_width">
                              <DatePicker
                                  className='input border-end'
                                  placeholder={row.check_in_date||"Check In"}
                                  disabledDate={(current) =>current && current.isBefore(dayjs(departure_flight_date, 'DD/MM/YYYY'))} 
                                  value={row.check_in_date ? dayjs(row.check_in_date, 'DD/MM/YYYY') : null}
                                  onChange={(date, dateString) => {
                                    
                                    handleHotelInputChange(index, 'check_in_date', dateString);
                                  }}
                                  format="DD/MM/YYYY"
                                 
                                  readOnly={!isAgencyProfile}
                                />
                                {/* <input type="date" className="border-end" value={row.check_in_date} onChange={(e) =>
                                  handleHotelInputChange(index, 'check_in_date', e.target.value)} placeholder="Check In" disabled  readOnly={!isAgencyProfile} /> */}

<DatePicker
                                  className='input '
                                  placeholder={row.check_out_date||"Check Out"}
                                  disabledDate={(current) =>current && current.isBefore(dayjs(row.check_in_date, 'DD/MM/YYYY'))} 
                                  value={row.check_out_date ? dayjs(row.check_out_date, 'DD/MM/YYYY') : null}
                                  onChange={(date, dateString) => {
                                    
                                    handleHotelInputChange(index, 'check_out_date', dateString);
                                  }}
                                  format="DD/MM/YYYY"
                                 
                                  readOnly={!isAgencyProfile}
                                />
                                {/* <input type="text" className="border-start" value={row.check_out_date} placeholder="Check Out" onChange={(e) =>
                                  handleHotelInputChange(index, 'check_out_date', e.target.value)} disabled  readOnly={!isAgencyProfile} /> */}

                              </div>
                            </div>

                            {/* Delete Button */}
                            {index !== 0 && (
                              <div className="col-md-1 py-0 px-1">
                                <button
                                  disabled={!isAgencyProfile}
                                  className="btn remove_btn mt-4 pt-1 px-1"
                                  onClick={() => handleDeleteHotelRow(index)}
                                >
                                  <i className="fa-solid fa-trash me-1"></i>
                                </button>
                              </div>)}
                          </div>
                        ))}

                        <div className="col-md-2 px-0">
                          <Link className="btn add_more_btn py-2 px-3" onClick={handleAddHotelRow} disabled={!isAgencyProfile}>
                            <i className="fa-solid fa-plus me-1"></i>Add New Hotel
                          </Link>
                        </div>
                      </>
                    }

                    {!isHotel &&
                      <div className="row my-2">
                        <div className="col-md-4 col-sm-12 px-1 my-2">
                          <label className="required">Adults Price</label>
                          <div className="input-group">
                            <input type="number" value={adults_price} onChange={(e) => setadults_price(e.target.value)} required readOnly={!isAgencyProfile} />
                            <select name="" id="" value={adults_currency} onChange={(e) => setadults_currency(e.target.value)} required readOnly={!isAgencyProfile}>
                              {configurations &&
                                configurations
                                  .filter((data) => data.type.trim().toLowerCase() === 'currency')
                                  .map((data) => (
                                    <option value={data.title} key={data._id}>
                                      {data.title}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12 px-1 my-2">
                          <label className="required">Child Price</label>
                          <div className="input-group">
                            <input type="number" value={childs_price} onChange={(e) => setchilds_price(e.target.value)} required readOnly={!isAgencyProfile} />
                            <select name="" id="" value={childs_currency} onChange={(e) => setchilds_currency(e.target.value)} required readOnly={!isAgencyProfile}>
                              {configurations &&
                                configurations
                                  .filter((data) => data.type.trim().toLowerCase() === 'currency')
                                  .map((data) => (
                                    <option value={data.title} key={data._id}>
                                      {data.title}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 px-1 my-2">
                          <label className="required">Infant Price</label>
                          <div className="input-group">
                            <input type="number" value={infant_price} onChange={(e) => setinfant_price(e.target.value)} required readOnly={!isAgencyProfile} />
                            <select name="" id="" value={infant_currency} onChange={(e) => setinfant_currency(e.target.value)} required readOnly={!isAgencyProfile}>
                              {configurations &&
                                configurations
                                  .filter((data) => data.type.trim().toLowerCase() === 'currency')
                                  .map((data) => (
                                    <option value={data.title} key={data._id}>
                                      {data.title}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    }

                  </div>
                  <hr />
                  {isHotel &&
                    <>
                      <div className="row my-2">
                        <h5 className="mb-2">Pricing details</h5>
                        {pricing && pricing.map((row, index) => (
                          <div key={index} className="row my-2">
                            <div className="col-md-2 px-1 my-2">
                              <label htmlFor={`room_type-${index}`} className="required">Room Type</label>
                              <select
                                id={`room_type-${index}`}
                                value={row.room_type}
                                onChange={(e) => handlePricingInputChange(index, 'room_type', e.target.value)}
                                required readOnly={!isAgencyProfile}
                              >
                                <option value="">Select</option>
                                <option value="Self Accomodation">Self Accomodation</option>
                                {configurations && configurations.filter(data => data.type.trim().toLowerCase() === 'room types').map((data, index) => (
                                  <option value={data.title} key={data._id}>{data.title}</option>
                                ))}

                              </select>
                            </div>
                            {['first_price', 'second_price', 'third_price'].map((priceType, idx) => (
                              <div key={idx} className="col-md-3 px-1 my-2">
                                <label className={`${priceType==='first_price'?"required":''}`}>
                                  {priceType === 'first_price'
                                    ? 'Adult Price (greater than 100)'
                                    : priceType === 'second_price'
                                      ? 'Child Price'
                                      : 'Infant Price'}
                                </label>
                                <div className="input-group">
                                  {/* Price Input */}
                                  <input
                                    type="number"
                                    min={`${priceType === 'first_price' ?"100":'0'}`}
                                    className=""
                                    // placeholder= {priceType === 'first_price'
                                    //   ? 'Adult Price'
                                    //   : priceType === 'second_price'
                                    //     ? 'Child Price'
                                    //     : 'Infant Price'}
                                    required={priceType === 'first_price'}
                                    value={row[priceType]?.price || ''}
                                    onChange={(e) =>
                                      handlePricingInputChange(index, `${priceType}.price`, Number(e.target.value))
                                    }

                                    readOnly={!isAgencyProfile}
                                  />
                                  {/* <TextField  label= {priceType === 'first_price'
                                   ? 'Adult Price'
                                   : priceType === 'second_price'
                                     ? 'Child Price'
                                     : 'Infant Price'} value={row[priceType]?.price || ''} // Access price dynamically
                                     onChange={(e) =>
                                       handlePricingInputChange(index, `${priceType}.price`, Number(e.target.value))
                                     }
                                      className='text-field'/> */}

                                  {/* Currency Dropdown */}
                                  <select
                                    className=""
                                    value={row[priceType]?.currency || ''} // Access currency dynamically
                                    onChange={(e) =>
                                      handlePricingInputChange(index, `${priceType}.currency`, e.target.value)
                                    }
                                    readOnly={!isAgencyProfile}
                                  >
                                    {configurations &&
                                      configurations
                                        .filter((data) => data.type.trim().toLowerCase() === 'currency')
                                        .map((data) => (
                                          <option value={data.title} key={data._id}>
                                            {data.title}
                                          </option>
                                        ))}

                                  </select>
                                </div>
                              </div>
                            ))}

                            {index !== 0 && (
                              <div className="col-md-1 py-0 px-1">
                                <button disabled={!isAgencyProfile}
                                  className="btn remove_btn mt-5 pt-0 px-1"
                                  onClick={() => handleDeleteRow(index)}
                                >
                                  <i className="fa-solid fa-trash me-1"></i>
                                </button>
                              </div>
                            )}
                          </div>
                        ))}

                        {pricing[0]?.room_type?.toLowerCase()!=='self accomodation' &&
                        <div className="col-md-2 px-0">
                        <Link className="btn add_more_btn py-2 px-3" disabled={!isAgencyProfile} onClick={handleAddRow}>
                          <i className="fa-solid fa-plus me-1"></i>Add New Pricing
                        </Link>
                      </div>
                        }
                        
                      </div>
                      <hr />
                    </>
                  }

                  <div className="row my-3">
                    <h5 className="mb-2">Transportation Types</h5>
                    <div className="d-flex flex-wrap gap-2">
                      {configurations &&
                        configurations
                          .filter((d) => d.type.toLowerCase() === 'transports' && d.isActive)
                          .map((data, index) => (
                            <Chip
                              disabled={!isAgencyProfile}
                              key={index}
                              className="border"
                              label={data.title 
                                ? data.title.charAt(0).toUpperCase() + data.title.slice(1) 
                                : ""}                              
                              icon={transport_details === data.title ? undefined : <AddIcon sx={{ fontSize: 18 }} />}
                              onClick={() => handleToggleTransport(data.title)}
                              sx={{
                                fontSize: 12,
                                color: transport_details === data.title ? 'white' : 'black',
                                background: transport_details === data.title ? '#08A5DC' : 'white',
                              }}
                              clickable
                              onDelete={
                                transport_details === data.title
                                  ? () => handleToggleTransport(data.title)
                                  : undefined
                              }
                            />
                          ))}

                    </div>
                  </div>
                  <hr />

                  <div className="row my-3">
                    <h5 className="mb-2">Transportation Trips </h5>
                    <div className="d-flex flex-wrap gap-2">

                      {configurations &&
                        configurations
                          .filter((d) => d.type.toLowerCase() === 'transportation services for' && d.isActive)
                          .map((data, index) => (
                            <Chip
                              disabled={!isAgencyProfile}
                              key={index}
                              className="border"
                              label={data.title 
                                ? data.title.charAt(0).toUpperCase() + data.title.slice(1) 
                                : ""}                              
                              icon={transport_services_for === data.title ? undefined : <AddIcon sx={{ fontSize: 18 }} />}
                              onClick={() => handleToggleTrasportServicesFor(data.title)}
                              sx={{
                                fontSize: 12,
                                color: transport_services_for === data.title ? 'white' : 'black',
                                background: transport_services_for === data.title ? '#08A5DC' : 'white',
                              }}
                              clickable
                              onDelete={
                                transport_services_for === data.title
                                  ? () => handleToggleTrasportServicesFor(data.title)
                                  : undefined
                              }
                            />
                          ))}
                    </div>
                  </div>
                  <hr />

                  <div className="row my-3">
                    <h5 className="mb-2">Facilities</h5>
                    <div className="d-flex flex-wrap gap-2">
                      {configurations &&
                        configurations
                          .filter((d) => d.type.toLowerCase() === 'facilities' && d.isActive)
                          .map((data, index) => (
                            <Chip
                              disabled={!isAgencyProfile}
                              key={index}
                              className="border"
                              label={data.title 
                                ? data.title.charAt(0).toUpperCase() + data.title.slice(1) 
                                : ""}                              
                              icon={!facilities.includes(data.title) ? <AddIcon sx={{ fontSize: 18 }} /> : undefined}
                              onClick={() => handleToggleFacilities(data.title)}
                              sx={{
                                fontSize: 12,
                                color: facilities.includes(data.title) ? 'white' : 'black',
                                background: facilities.includes(data.title) ? '#08A5DC' : 'white',
                              }}
                              clickable
                              onDelete={
                                facilities.includes(data.title)
                                  ? () => handleToggleFacilities(data.title)
                                  : undefined
                              }
                            />
                          ))}

                    </div>
                  </div>
                  <hr />
                  <div className="row my-3">
                    <h5 className="mb-2">Ziyarat Included</h5>
                    <div className="d-flex flex-wrap gap-2">
                      {configurations &&
                        configurations
                          .filter((d) => d.type.toLowerCase() === 'ziyarats' && d.isActive)
                          .map((data, index) => (
                            <Chip
                              disabled={!isAgencyProfile}
                              key={index}
                              className="border"
                              label={data.title 
                                ? data.title.charAt(0).toUpperCase() + data.title.slice(1) 
                                : ""}                              
                              icon={ziyarat === data.title ? undefined : <AddIcon sx={{ fontSize: 18 }} />}
                              onClick={() => handleToggleZiyarat(data.title)}
                              sx={{
                                fontSize: 12,
                                color: ziyarat === data.title ? 'white' : 'black',
                                background: ziyarat === data.title ? '#08A5DC' : 'white',
                              }}
                              clickable
                              onDelete={
                                ziyarat === data.title
                                  ? () => handleToggleZiyarat(data.title)
                                  : undefined
                              }
                            />
                          ))}

                    </div>
                  </div>
                  <hr />

                </div>
                {/* Navigation Buttons */}
                <div className="d-flex justify-content-between mt-4 px-3">
                  <button className="px-3 py-2 back_btn me-2" onClick={() => { setNewPackage(false); resetFormStates() }} disabled={loading1}>
                    Cancel
                  </button>
                  {isAgencyProfile &&
                    <button className="px-3 py-2 save_btn" disabled={loading1}>{loading1 ? "Saving" : "save"}</button>
                  }

                </div>
              </div>
            </form>
          </div>
        }

        {/* Hajj Packages */}

        {(newPackage && package_header.trim().toLowerCase() === 'hajj package') &&
          <div className="row mt-5 pt-4">
            <form onSubmit={editedPackageId ? updatePackage : handleFormSubmit}>
              <div className="col-md-12 data_table p-2 pt-1 pb-3 my-auto new_package">
                <div className="card p-4 border-0">
                  <div className="row">
                    <div className="d-flex justify-content-between px-1 info_header">
                      <div className="left">
                        <h4 className="mb-3">{editedPackageId ? "Edit the" : "Enter the"} package details</h4>
                      </div>

                    </div>
                    <hr />
                  </div>
                  <div className="row my-2">
                    <h5 className="mb-2">Package Details</h5>
                    <div className="col-md-3 px-1 my-2">
                      <label className="required">
                        Package Name
                      </label>
                      <input type="text" value={package_title} onChange={(e) => setpackage_title(e.target.value)}
                        // placeholder="Package Name" 
                        required readOnly={!isAgencyProfile} />
                    </div>

                    <div className="col-md-3 px-1 my-2">
                      <label className="required">
                        Hajj Duration
                      </label>
                      <select

                        value={duration} onChange={(e) => setduration(e.target.value)}
                        required readOnly={!isAgencyProfile}
                      >
                        <option value=""> Select</option>
                        <option value="Short Duration">Short Duration</option>
                        <option value="Long Duration">Long Duration</option>
                      </select>
                    </div>
                    <div className="col-lg-3 col-md-6 col-12 px-1 my-2">
                      <label htmlFor="" className='required'>
                        Available Slots
                      </label>
                      {/* <TextField fullWidth value={package_code} onChange={(e) => setpackage_code(e.target.value)} label="Package Code/ID" className='text-field'/> */}

                      <input type="number" value={total_slots} onChange={(e) => settotal_slots(e.target.value)} required readOnly={!isAgencyProfile} />
                    </div>

                    <div className="col-md-3 px-1 my-2">
                      <label className="required">
                        Departure From
                      </label>
                      <select name="" id="" value={departure_from_id} 
                      onChange={(e) => {
                        setdeparture_from('')
                        setdeparture_from_id('');
                        const value = e.target.value
                        setdeparture_from_id(e.target.value);
                        const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                        if (findId) {
                          setdeparture_from(findId.airport_name)
                        }
                      }}
                       required readOnly={!isAgencyProfile}>
                        <option value="">Select</option>

                        {defaultconfigurations &&
                            defaultconfigurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports'&&data.country.toLowerCase().includes('pakistan'))
                              .map((data, index) => (
                                <option value={data._id} key={data._id}>
                                  {data.airport_name} - {data.iata_code}
                                </option>
                              ))}

                          {/* {configurations &&
                            configurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports')
                              .map((data, index) => (
                                <option value={data.title} key={data._id}>
                                  {data.title}
                                </option>
                              ))} */}
                        <option value="Any">Any</option>
                      </select>
                    </div>

                    <div className="col-md-4 px-1 my-2">
                      <label className="required">
                        Mina Category
                      </label>
                      <select name="" id="" value={category} onChange={(e) => setcategory(e.target.value)} required readOnly={!isAgencyProfile}>
                        <option value="">Select</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                        <option value="E">E</option>

                      </select>
                    </div>
                    <div className="col-md-4 px-1 my-2">
                      <label className="required">
                        Mina Zone
                      </label>
                      <select name="" id="" value={zone} onChange={(e) => setzone(e.target.value)} required readOnly={!isAgencyProfile}>
                        <option value="">Select</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </select>
                    </div>

                    <div className="col-md-4 px-1 my-2">
                      <label className="required">
                        Distance From Hotel In Makkah(meters)
                      </label>
                      <input type="text" value={distance_from_makkah_hotel} onChange={(e) => setdistance_from_makkah_hotel(e.target.value)}
                        // placeholder=" Distance From Hotel In Makkah(meters)" 
                        required readOnly={!isAgencyProfile} />
                    </div>

                    <div className="col-md-4 px-1 my-2">
                      <label className="required">
                        Distance From Hotel In Madinah(meters)
                      </label>
                      <input type="text" value={distance_from_madina_hotel} onChange={(e) => setdistance_from_madina_hotel(e.target.value)}
                        //  placeholder="Distance From Hotel In Madina(meters)"
                        required readOnly={!isAgencyProfile} />
                    </div>
                    <div className="col-md-4 px-1 my-2">
                      <label className="required">
                        Building-Haram Transport
                      </label>
                      <select name="" id="" value={transport} onChange={(e) => settransport(e.target.value)} required readOnly={!isAgencyProfile}>
                        <option value="">Select</option>

                        {configurations && configurations.filter(data => data.type.trim().toLowerCase() === 'transports').map((data, index) => (
                          <option value={data.title} key={data._id}>{data.title}</option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4 px-1 my-2">
                      <label className="required">
                        Mashier Transport
                      </label>
                      <select name="" id="" value={mina_transport} onChange={(e) => setmina_transport(e.target.value)} required readOnly={!isAgencyProfile}>
                        <option value="">Select</option>
                        <option value="By Saudi Mualim">By Saudi Mualim</option>
                        <option value="Special Transport">Special Transport</option>
                      </select>
                    </div>

                    <div className="col-md-4 px-1 my-2">
                      <label className="required">
                        Ziyarats Included
                      </label>
                      <select name="" id="" value={ziayarat_included} onChange={(e) => setziayarat_included(e.target.value === 'true')} required readOnly={!isAgencyProfile}>
                        {/* <option value="">Select</option> */}
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>


                    <div className="col-md-4 px-1 my-2">
                      <label className="required">
                        Gifts Included
                      </label>
                      <select name="" id="" value={gifts_included} onChange={(e) => setgifts_included(e.target.value === 'true')} required readOnly={!isAgencyProfile}>
                        {/* <option value="">Select</option> */}
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                    <div className="col-md-4 px-1 my-2">
                      <label className="required">
                        Azizia Included
                      </label>
                      <select name="" id="" value={azizia_included} onChange={(e) => setazizia_included(e.target.value === 'true')} required readOnly={!isAgencyProfile}>
                        {/* <option value="">Select</option> */}
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                    <div className="col-md-4 px-1 my-2">
                      <label className="required">
                        Markazia Included
                      </label>
                      <select name="" id="" value={markazia_included} onChange={(e) => setmarkazia_included(e.target.value === 'true')} required readOnly={!isAgencyProfile}>
                        {/* <option value="">Select</option> */}
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                    <div className="col-md-4 px-1 my-2">
                      <label className="required">
                        Food Included
                      </label>
                      <select name="" id="" value={food_included} onChange={(e) => setfood_included(e.target.value)} required readOnly={!isAgencyProfile}>
                        <option value="">Select</option>
                        <option value="Boofa System">Boofa System</option>
                        <option value="3 times dish (1 dish parcel)">3 times dish (1 dish parcel)</option>
                        <option value="3 times dish (2 dish parcel)">3 times dish (2 dish parcel)</option>
                        <option value="No">None</option>

                      </select>
                    </div>

                    <div className="col-md-4 px-1 my-2">
                      <label className="required">
                        Qurbani Included
                      </label>
                      <select name="" id="" value={qurbani_included} onChange={(e) => setqurbani_included(e.target.value === 'true')} required readOnly={!isAgencyProfile}>
                        {/* <option value="">Select</option> */}
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>

                    <div className="col-md-9 px-1 my-2">
                      <label >
                        Package description
                      </label>
                      <textarea name="" id=""
                        placeholder="Add description" value={package_description} onChange={(e) => setpackage_description(e.target.value)} readOnly={!isAgencyProfile}></textarea>
                    </div>
                    <div className="col-md-3 px-1 my-2">
                      <label htmlFor="file-upload">Add Cover Image</label>
                      {!cover_image ? (
                        <label htmlFor="file-upload" className="custom-file-upload d-flex flex-column align-items-center">
                          <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">

                          </svg>
                          <h6 className="mt-1">
                            Upload Package Image
                            <p className="text-muted">or drag and drop SVG, PNG, JPG, or GIF (max. 800x400px)</p>
                          </h6>
                          <input
                            id="file-upload"
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={handleImage}
                          />
                        </label>
                      ) : (
                        <div className="selected-image">
                          <label htmlFor="selected-file-upload">
                            <img
                              src={cover_image}
                              alt="Cover"
                              style={{ cursor: 'pointer' }}
                            />
                          </label>
                          <input
                            id="selected-file-upload"
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={handleImage}
                            readOnly={!isAgencyProfile}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <hr />

                  <div className="my-3">
                    <h5 className="mb-2">Pricing details</h5>
                    {pricing && pricing.map((row, index) => (
                      <div key={index} className="row my-2">
                        <div className="col px-1 my-2">
                          <label htmlFor={`room_type-${index}`} className="required">Hajj Duration</label>
                          <select
                            id={`room_type-${index}`}
                            value={row.room_type}
                            onChange={(e) => handlePricingInputChange(index, 'room_type', e.target.value)}
                            required
                            disabled
                          >
                            <option value={duration}>{duration}</option>


                          </select>
                        </div>
                        {['first_price', 'fourth_price', 'second_price', 'third_price'].map((priceType, idx) => (
                          <div key={idx} className="col px-1 my-2">
                            <label className={`${priceType==='first_price'?"required":''}`}>
                              {priceType === 'first_price'
                                ? 'Sharing (greater than 100)'
                                : priceType === 'fourth_price'
                                  ? 'Four Bed' :
                                  priceType === 'second_price'
                                    ? 'Three Beds'
                                    : 'Double Bed'}
                            </label>
                            <div className="input-group hajj_input_group">
                              <input
                                type="number"
                                min={`${priceType === 'first_price' ?"100":'0'}`}
                                className=""
                                // placeholder={priceType === 'first_price'
                                //   ? 'Sharing Package'
                                //   : priceType === 'second_price'
                                //     ? 'Three Beds Package'
                                //     : 'Double Bed Package'}
                                value={row[priceType]?.price || ''} // Access price dynamically
                                required={priceType === 'first_price'}
                                onChange={(e) =>
                                  handlePricingInputChange(index, `${priceType}.price`, Number(e.target.value))
                                }
                                readOnly={!isAgencyProfile}
                              />
                              {/* Currency Dropdown */}
                              <select
                                className=""
                                value={row[priceType]?.currency || ''} // Access currency dynamically
                                onChange={(e) =>
                                  handlePricingInputChange(index, `${priceType}.currency`, e.target.value)
                                }
                                readOnly={!isAgencyProfile}
                              >

                                {configurations &&
                                  configurations
                                    .filter((data) => data.type.trim().toLowerCase() === 'currency')
                                    .map((data) => (
                                      <option value={data.title} key={data._id}>
                                        {data.title}
                                      </option>
                                    ))}
                                <option value="PKR">PKR</option>
                                <option value="USD">USD</option>
                                <option value="SAR">SAR</option>
                              </select>
                            </div>
                          </div>
                        ))}

                        {index !== 0 && (
                          <div className="col-md-1 py-0 px-1">
                            <button disabled={!isAgencyProfile}
                              className="btn remove_btn mt-5 pt-0 px-1"
                              onClick={() => handleDeleteRow(index)}
                            >
                              <i className="fa-solid fa-trash me-1"></i>
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                    {/* <div className="col-md-2 px-0">
                    <button className="btn add_more_btn py-2 px-3" onClick={handleAddRow}>
                      <i className="fa-solid fa-plus me-1"></i>Add New Pricing
                    </button>
                  </div> */}
                  </div>
                </div>

                <div className="d-flex justify-content-between mt-4 px-3">
                  <button className="px-3 py-2 back_btn me-2" onClick={() => { setNewPackage(false); resetFormStates() }} disabled={loading1}>
                    Cancel
                  </button>
                  {isAgencyProfile &&
                    <button className="px-3 py-2 save_btn" disabled={loading1}>{loading1 ? "Saving" : "Save"}</button>
                  }

                </div>
              </div>
            </form>
          </div>
        }










        {/* New Umrah Package section - New Design*/}
        {(isNewDesign&&newPackage && package_header.trim().toLowerCase() === 'umrah package') &&
          <div className="row mt-5 pt-4 justify-content-center">
            <form onSubmit={editedPackageId ? updatePackage : handleFormSubmit}>
              <div className="col-md-12 data_table p-2 pt-1 pb-3 my-auto package_new_design">
                {/* Step Content */}
                <div className="card p-4 border-0 ">

                  <div className="row ">
                    <div className="d-flex justify-content-between px-1 mb-3 info_header">
                      <div className="left">
                      <h4 className="my-auto text-center">{editedPackageId ? "Edit Umrah" : "Create New Umrah"} Package </h4>
                      </div>
                      <div className="right">
                        <button className="px-3 py-2 submit_btn my-auto bg-success mx-1" type='button' disabled={loading1} onClick={()=>VoucherPreview()}><i className="fa-solid fa-eye me-2"></i>Preview</button>
                        {(editedPackageId && isAgencyProfile) && <button className="px-3 py-2 submit_btn my-auto" type='submit' disabled={loading1}><i className="fa-solid fa-floppy-disk me-2"></i>{loading1 ? "Saving" : "Save Package"}</button>}
                      </div>
                    </div>
                    <hr />
                  </div>
                  <div className="row my-3 package_section_part p-md-4 p-3">
                  <h5 className="mb-2"><i className="fa-solid fa-cube success_text me-2"></i>Enter the package details</h5>
                    <div className="col-lg-3 col-md-6 col-12 px-1 my-2">
                      <label className="required">
                        Package Name
                      </label>
                      {/* <TextField fullWidth value={package_title}  onChange={(e) => setpackage_title(e.target.value)} label="Package Name" className='text-field'/> */}
                      <input type="text" placeholder="e.g., Deluxe Umrah 2025" value={package_title} onChange={(e) => setpackage_title(e.target.value)}
                        // placeholder="Package name "
                        required readOnly={!isAgencyProfile} />
                    </div>
                    <div className="col-lg-3 col-md-6 col-12 px-1 my-2">
                      <label htmlFor="">
                        Package Code/ID
                      </label>
                      {/* <TextField fullWidth value={package_code} onChange={(e) => setpackage_code(e.target.value)} label="Package Code/ID" className='text-field'/> */}

                      <input type="text" placeholder="e.g., UMRAH-DLUX-001" value={package_code} onChange={(e) => setpackage_code(e.target.value)}
                        // placeholder="Package Code/ID"
                        readOnly={!isAgencyProfile}
                      />

                    </div>
                    <div className="col-lg-3 col-md-6 col-12 px-1 my-2">
                      <label htmlFor="" className='required'>
                        Available Slots
                      </label>
                      {/* <TextField fullWidth value={package_code} onChange={(e) => setpackage_code(e.target.value)} label="Package Code/ID" className='text-field'/> */}

                      <input type="number" min="0" pattern='[0-9]*' value={total_slots} onChange={(e) => settotal_slots(e.target.value)} required readOnly={!isAgencyProfile} />

                    </div>
                    <div className="col-lg-3 col-md-6 col-12 px-1 my-2">
                      <label className="required">
                        Duration (In days)
                      </label>
                      {/* <TextField fullWidth value={duration} onChange={(e) => setduration(e.target.value)} label="Duration (In Days)" className='text-field'/> */}

                      <input type="number" min='0' pattern='[0-9]*' value={duration} onChange={(e) => setduration(e.target.value)}
                        // placeholder='Duration (In Days)'
                        required readOnly={!isAgencyProfile} />
                    </div>
                    <div className="col-lg-6 col-md-12 col-12 px-1 my-2">
                      <label>
                        Package description
                      </label>
                      <textarea name="" id=""
                        placeholder='Brief description of package'
                        value={package_description} onChange={(e) => setpackage_description(e.target.value)} readOnly={!isAgencyProfile}></textarea>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12 px-1 my-2">
                      <label htmlFor="file-upload" >Add Cover Image</label>
                      {!cover_image ? (
                        <label htmlFor="file-upload" className="custom-file-upload d-flex flex-column align-items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                          </svg>

                          <h6 className="mt-1">
                            Click to upload
                            <p className="text-muted">or drag and drop SVG, PNG, JPG, or GIF (max. 800x400px)</p>
                          </h6>
                          <input
                            id="file-upload"
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={handleImage}
                            readOnly={!isAgencyProfile}
                          />
                        </label>
                      ) : (
                        <div className="selected-image">
                          <label htmlFor="selected-file-upload">
                            <img
                              src={cover_image}
                              alt="Cover"
                              style={{ cursor: 'pointer' }}
                            />
                          </label>
                          <input
                            id="selected-file-upload"
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={handleImage}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <hr />

                  <div className="row my-3 package_section_part p-md-4 p-3">
                    <h5 className="mb-2"><i className="fa-solid fa-plane-departure primary_text me-2"></i>Departure Flight</h5>
                    <div className="col-md-4 px-1 my-2">
                      <label >
                        Airline Name
                      </label>
                      
                      <select name="" id="" value={departure_airline_id} onChange={(e) => {
                        setdeparture_airline_name('')
                        setdeparture_airline_id('');
                        const value = e.target.value
                        setdeparture_airline_id(e.target.value);
                        setarrival_airline_id(e.target.value);
                        const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                        if (findId) {
                          setdeparture_airline_name(findId.name)
                          setarrival_airline_name(findId.name)
                        }
                      }}  readOnly={!isAgencyProfile}>

                        <option value="">Select</option>
                        {defaultconfigurations && defaultconfigurations.filter(data => data.type.trim().toLowerCase() === 'airlines').map((data, index) => (
                          <option value={data._id} key={data._id}>{data.name} - {data.iata_code}</option>
                        ))}

                        {configurations && configurations.filter(data => data.type.trim().toLowerCase() === 'airlines').map((data, index) => (
                          <option value={data.title} key={data._id}>{data.title}</option>
                        ))}

                       </select> 
                    </div>

                    <div className="col-md-4 px-1 my-2">
                      <label>
                        Flight Class
                      </label>
                      <select name="" id="" value={departure_flight_class} onChange={(e) => {setdeparture_flight_class(e.target.value);setarrival_flight_class(e.target.value)}} readOnly={!isAgencyProfile}>
                        <option value="">Select</option>

                        {defaultconfigurations && defaultconfigurations.filter(data => data.type.trim().toLowerCase() === 'flight class').map((data, index) => (
                          <option value={data.flight_class} key={data._id}>{data.flight_class}</option>
                        ))}
                        

                      </select>
                    </div>

                    <div className="col-md-4 px-1 my-2">
                      <label htmlFor="">
                        Flight Number
                      </label>
                     
                      <input type="text"
                         placeholder="Flight Number (Optional)"
                        value={departure_flight_number} onChange={(e) => setdeparture_flight_number(e.target.value)} readOnly={!isAgencyProfile} />
                    </div>
                    <div className="col-xl-4 col-md-6 px-1 my-2">
                          <label >Departure City</label>
                        <select
                          name=""
                          id=""
                          className="border-end"
                          value={departure_location_id}
                          onChange={(e) => {
                            setdeparture_location('')
                            setdeparture_location_id('');
                            const value = e.target.value
                            setdeparture_location_id(e.target.value);
                            const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                            if (findId) {
                              setdeparture_location(findId.airport_name)
                            }
                          }}
                          
                          readOnly={!isAgencyProfile}
                        >
                          <option value="">Select</option>

                          {defaultconfigurations &&
                            defaultconfigurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports' &&data.country.toLowerCase().includes('pakistan'))
                              .map((data, index) => (
                                <option value={data._id} key={data._id}>
                                  {data.airport_name} - {data.iata_code}
                                </option>
                              ))}

                          
                        </select>
                       
                  
                    </div>

                     <div className="col-xl-4 col-md-6 px-1 my-2">
                      
                          <label >Arrival City</label>
                        <select
                          name=""
                          id=""
                          value={departure_to_location_id}
                          onChange={(e) => {
                            setdeparture_to_location('')
                            setdeparture_to_location_id('');
                            const value = e.target.value
                            setdeparture_to_location_id(e.target.value);
                            const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                            if (findId) {
                              setdeparture_to_location(findId.airport_name)
                            }
                          }}
                           readOnly={!isAgencyProfile}
                        >

                          <option value="">Select</option>
                          {defaultconfigurations &&
                            defaultconfigurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports'&&data.country.toLowerCase().includes('saudi'))
                              .map((data, index) => (
                                <option value={data._id} key={data._id}>
                                  {data.airport_name} - {data.iata_code}
                                </option>
                              ))}
                        </select>
                    
                    </div>

                    <div className="col-xl-4 col-md-6 px-1 my-2">
                          <label >Departure Date</label>
                      <DatePicker  className='input' disabledDate={(current) =>current && current.isBefore(dayjs(new Date().toISOString().split("T")[0], 'DD/MM/YYYY'))} value={departure_flight_date ? dayjs(departure_flight_date, 'DD/MM/YYYY') : null} placeholder={departure_flight_date||"Departure Date"}  onChange={(date, dateString) => setdeparture_flight_date(dateString)} readOnly={!isAgencyProfile} format="DD/MM/YYYY"/>
                        {/* <input
                          type="text"
                          placeholder="Departure date"
                          onFocus={(e) => (e.target.type = "date")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='' min={new Date().toISOString().split("T")[0]} value={departure_flight_date} onChange={(e) => setdeparture_flight_date(e.target.value)} readOnly={!isAgencyProfile} /> */}
                    </div>

                     <div className="col-xl-4 col-md-6 px-1 my-2">
                          <label >Departure Time</label>
                  
                          <TimePicker
                            className="input"
                            placeholder={departure_time}
                                      onChange={(time,timeString) => setdeparture_time(timeString)}
                                      defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                      format="HH:mm" // To ensure 24-hour format if not already set by default
                                  />
                        {/* <input
                          type="text"
                          placeholder="Departure time"
                          onFocus={(e) => (e.target.type = "time")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='border-start' value={departure_time} onChange={(e) => setdeparture_time(e.target.value)} readOnly={!isAgencyProfile} /> */}
                    </div>

                    <div className="col-xl-4 col-md-6 px-1 my-2">
                          <label >Arrival Date</label>
                      <DatePicker  className='input' disabledDate={(current) =>current && current.isBefore(dayjs(departure_flight_date,'DD/MM/YYYY'))} value={departure_to_flight_date ? dayjs(departure_to_flight_date, 'DD/MM/YYYY') : null} placeholder={departure_to_flight_date||"Arrival Date"} onChange={(date, dateString) => setdeparture_to_flight_date(dateString)} readOnly={!isAgencyProfile} format="DD/MM/YYYY"/>

                        {/* <input
                          type="text"
                          placeholder="Arrival date"
                          onFocus={(e) => (e.target.type = "date")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='' min={departure_flight_date} value={departure_to_flight_date} onChange={(e) => setdeparture_to_flight_date(e.target.value)} readOnly={!isAgencyProfile} /> */}
                  </div>

                   <div className="col-xl-4 col-md-6 px-1 my-2">
                          <label>Arrival Time</label> 
                          <TimePicker
                            className="input"
                            placeholder={departure_to_time}

                                      onChange={(time,timeString) => setdeparture_to_time(timeString)}
                                      defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                      format="HH:mm" // To ensure 24-hour format if not already set by default
                                  />
                        {/* <input
                          type="text"
                          placeholder="Arrival time"
                          onFocus={(e) => (e.target.type = "time")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='border-start' value={departure_to_time} onChange={(e) => setdeparture_to_time(e.target.value)} readOnly={!isAgencyProfile} /> */}
                    </div>
                  </div>


                  
                  <div className="row my-3 package_section_part p-md-4 p-3">
                    <h5 className="mb-2"><i className="fa-solid fa-plane-arrival primary_text me-2"></i>Return Flight</h5>
                    <div className="col-md-4 px-1 my-2">
                      <label>
                        Airline Name
                      </label>
                      <select name="" id="" value={arrival_airline_id}
                        onChange={(e) => {
                          setarrival_airline_name('')
                          setarrival_airline_id('');
                          const value = e.target.value
                          setarrival_airline_id(e.target.value);
                          const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                          if (findId) {
                            setarrival_airline_name(findId.name)
                            
                          }
                        }}
                         readOnly={!isAgencyProfile}>
                        <option value="">Select</option>
                        {defaultconfigurations && defaultconfigurations.filter(data => data.type.trim().toLowerCase() === 'airlines').map((data, index) => (
                          <option value={data._id} key={data._id}>{data.name} - {data.iata_code}</option>
                        ))}

                        {/* {configurations && configurations.filter(data => data.type.trim().toLowerCase() === 'airlines').map((data, index) => (
                          <option value={data.title} key={data._id}>{data.title}</option>
                        ))} */}

                      </select>
                    </div>
                    <div className="col-md-4 px-1 my-2">
                      <label>
                        Flight Class
                      </label>
                      <select name="" id="" value={arrival_flight_class} onChange={(e) => setarrival_flight_class(e.target.value)} readOnly={!isAgencyProfile}>

                        <option value="">Select</option>

                        {defaultconfigurations && defaultconfigurations.filter(data => data.type.trim().toLowerCase() === 'flight class').map((data, index) => (
                          <option value={data.flight_class} key={data._id}>{data.flight_class}</option>
                        ))}
                        {/* {configurations && configurations.filter(data => data.type.trim().toLowerCase() === 'flight class').map((data, index) => (
                          <option value={data.title} key={data._id}>{data.title}</option>
                        ))} */}

                      </select>
                    </div>
                    <div className="col-md-4 px-1 my-2">
                      <label htmlFor="">
                        Flight Number
                      </label>
                      <input type="text"
                        // placeholder="Flight Number (Optional)" 
                        value={arrival_flight_number} onChange={(e) => setarrival_flight_number(e.target.value)} readOnly={!isAgencyProfile} />
                    </div>

                    <div className="col-xl-4 col-md-6 px-1 my-2">
                          <label >Departure City</label>  
                        <select name="" id="" className='border-end' value={arrival_location_id}
                          onChange={(e) => {
                            setarrival_location('')
                            setarrival_location_id('');
                            const value = e.target.value
                            setarrival_location_id(e.target.value);
                            const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                            if (findId) {
                              setarrival_location(findId.airport_name)
                            }
                          }}
                           readOnly={!isAgencyProfile}>
                          <option value="">Select</option>
                          {defaultconfigurations &&
                            defaultconfigurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports'&&data.country.toLowerCase().includes('saudi'))
                              .map((data, index) => (
                                <option value={data._id} key={data._id}>
                                  {data.airport_name} - {data.iata_code}
                                </option>
                              ))}

                          
                        </select>
                       
                    </div>


                    <div className="col-xl-4 col-md-6 px-1 my-2">
                          <label >Arrival City</label> 
                        <select name="" id="" className='border-start' value={take_off_location_id}
                          onChange={(e) => {
                            settake_off_location('')
                            settake_off_location_id('');
                            const value = e.target.value
                            settake_off_location_id(e.target.value);
                            const findId = defaultconfigurations && defaultconfigurations.find(c => c._id === value)
                            if (findId) {
                              settake_off_location(findId.airport_name)
                            }
                          }}
                           readOnly={!isAgencyProfile}>
                          <option value="">Select</option>
                          {defaultconfigurations &&
                            defaultconfigurations
                              .filter((data) => data.type.trim().toLowerCase() === 'airports'&&data.country.toLowerCase().includes('pakistan'))
                              .map((data, index) => (
                                <option value={data._id} key={data._id}>
                                  {data.airport_name} - {data.iata_code}
                                </option>
                              ))}

                          

                        </select>
                      
                    </div>


                    <div className="col-xl-4 col-md-6 px-1 my-2">
                     
                          <label >Departure Date</label>
                      <DatePicker  className='input' value={arrival_flight_date ? dayjs(arrival_flight_date, 'DD/MM/YYYY') : null} disabledDate={(current) =>current && current.isBefore(dayjs(departure_flight_date, 'DD/MM/YYYY'))} placeholder={arrival_flight_date||"Departure Date"} onChange={(date, dateString) => setarrival_flight_date(dateString)} readOnly={!isAgencyProfile} format="DD/MM/YYYY"/>
                       
                        {/* <input
                          type="text"
                          placeholder="Departure date"
                          onFocus={(e) => (e.target.type = "date")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='' min={departure_flight_date} value={arrival_flight_date} onChange={(e) => {setarrival_flight_date(e.target.value);settake_off_flight_date(e.target.value)}} readOnly={!isAgencyProfile} /> */}
                      

                    </div>



                    <div className="col-xl-4 col-md-6 px-1 my-2">
                      
                          <label>Departure Time</label>
                       <TimePicker
                            className="input"
                            placeholder={arrival_time}

                                      onChange={(time,timeString) => setarrival_time(timeString)}
                                      defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                      format="HH:mm" // To ensure 24-hour format if not already set by default
                                  />
                        {/* <input
                          type="text"
                          placeholder="Departure time"
                          onFocus={(e) => (e.target.type = "time")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='border-start' value={arrival_time} onChange={(e) => setarrival_time(e.target.value)} readOnly={!isAgencyProfile} /> */}
                      

                    </div>



                    <div className="col-xl-4 col-md-6 px-1 my-2">
                      
                          <label >Arrival Date</label>
                      <DatePicker  className='input' value={take_off_flight_date ? dayjs(take_off_flight_date, 'DD/MM/YYYY') : null} disabledDate={(current) =>current && current.isBefore(dayjs(departure_flight_date, 'DD/MM/YYYY'))} placeholder={take_off_flight_date||"Arrival Date"} onChange={(date, dateString) => settake_off_flight_date(dateString)} readOnly={!isAgencyProfile} format="DD/MM/YYYY"/>
                       
                        {/* <input
                          type="text"
                          placeholder="Arrival date"
                          onFocus={(e) => (e.target.type = "date")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='' min={arrival_flight_date} value={take_off_flight_date} onChange={(e) => settake_off_flight_date(e.target.value)} readOnly={!isAgencyProfile} /> */}
                       

                    </div>


                    <div className="col-xl-4 col-md-6 px-1 my-2">
                      
                          <label >Arrival Time</label>
                                    <TimePicker
                            className="input"
                            placeholder={take_off_time}

                                      onChange={(time,timeString) => settake_off_time(timeString)}
                                      defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                      format="HH:mm" // To ensure 24-hour format if not already set by default
                                  />
                        {/* <input
                          type="text"
                          placeholder="Arrival time"
                          onFocus={(e) => (e.target.type = "time")}
                          onBlur={(e) => {
                            if (!e.target.value) e.target.type = "text";
                          }}
                          className='border-start' value={take_off_time} onChange={(e) => settake_off_time(e.target.value)} readOnly={!isAgencyProfile} /> */}
                     

                    </div>

                  </div>
                  <hr />


                  <div className="row my-3 package_section_part p-md-4 p-3">
                    <h5 className="mb-2"><i className="fa-solid fa-hotel warning_text me-2"></i>Add Hotel Details</h5>
                    
                    {isHotel &&
                      <>
                        {accomodation_details.map((row, index) => (
                          <div key={index} className="row my-1 align-items-center">

                            <div className="col-md-2 px-1 my-1">
                              <label >Hotel City</label>
                              <select name="" id="" value={row.hotel_city}
                                onChange={(e) => {
                                  handleHotelInputChange(index, 'hotel_city', e.target.value);
                                }
                                } readOnly={!isAgencyProfile}>
                                <option value="">Select</option>
                                <option value="makkah">MAKKAH</option>
                                <option value="madinah">MADINAH</option>
                              </select>

                            </div>
                            <div className="col-md-3 px-1 my-1">
                              <label >Hotel Name</label>
                              <select name="" id="" value={row.hotel_name} onChange={(e) => {
                                handleHotelInputChange(index, 'hotel_name', e.target.value)

                              }}  readOnly={!isAgencyProfile}>
                                <option value="">Select</option>
                                {configurations && configurations.filter(data => data.type.trim().toLowerCase() === 'hotels' && data.location.trim().toLowerCase() === row.hotel_city.trim().toLowerCase()).map((data, index) => (
                                  <option value={data.title} key={data._id}>{data.title}</option>
                                ))}
                                 {defaultconfigurations && defaultconfigurations.filter(data => data.type.trim().toLowerCase() === 'hotels').map((data, index) => (
                                  <option value={data.name} key={data._id}>{data.name}</option>
                                ))}
                              </select>

                            </div>


                            {/* Hotel Duration */}
                            <div className="col-md-2 px-1 my-1">
                              <label >Duration (In Days)</label>
                              <input
                                type="text"

                                disabled={!duration}
                                value={row.hotel_duration}
                                onChange={(e) =>
                                  handleHotelInputChange(index, 'hotel_duration', e.target.value)
                                }
                                readOnly={!isAgencyProfile}
                              />
                            </div>

                            <div className="col-md-2 px-1 my-1">
                                  <label >Check In</label>  
                                  <DatePicker
                                  className='input'
                                  placeholder={row.check_in_date||"Check In"}
                                  disabledDate={(current) =>current && current.isBefore(dayjs(departure_flight_date, 'DD/MM/YYYY'))} 
                                  value={row.check_in_date ? dayjs(row.check_in_date, 'DD/MM/YYYY') : null}
                                  onChange={(date, dateString) => {
                                    
                                    handleHotelInputChange(index, 'check_in_date', dateString);
                                  }}
                                  format="DD/MM/YYYY"
                                 
                                  readOnly={!isAgencyProfile}
                                />
                                {/* <input type="text" className="border-end" value={row.check_in_date} onChange={(e) =>
                                  handleHotelInputChange(index, 'check_in_date', e.target.value)} placeholder="Check In" disabled  readOnly={!isAgencyProfile} />  */}
                            </div>

                            <div className="col-md-2 px-1 my-1">
                                  <label >Check Out</label>
                                  <DatePicker
                                  className='input '
                                  placeholder={row.check_out_date||"Check Out"}
                                  disabledDate={(current) =>current && current.isBefore(dayjs(row.check_in_date, 'DD/MM/YYYY'))} 
                                  value={row.check_out_date ? dayjs(row.check_out_date, 'DD/MM/YYYY') : null}
                                  onChange={(date, dateString) => {
                                    
                                    handleHotelInputChange(index, 'check_out_date', dateString);
                                  }}
                                  format="DD/MM/YYYY"
                                 
                                  readOnly={!isAgencyProfile}
                                />
                                {/* <input type="text" className="border-start" value={row.check_out_date} placeholder="Check Out" onChange={(e) =>
                                  handleHotelInputChange(index, 'check_out_date', e.target.value)} disabled  readOnly={!isAgencyProfile} />                               */}
                            </div>

                            {/* Delete Button */}
                            {index !== 0 && (
                              <div className="col-md-1 pt-2 px-1 my-auto">
                                <button
                                  disabled={!isAgencyProfile}
                                  className="btn remove_btn mt-4 pt-1 px-1"
                                  onClick={() => handleDeleteHotelRow(index)}
                                >
                                <i className="fa-solid fa-xmark"></i>
                                </button>
                              </div>)}
                          </div>
                        ))}

                        <div className="col-md-2 px-0">
                          <Link className="btn add_hotel_btn py-2 px-3" onClick={handleAddHotelRow} disabled={!isAgencyProfile}>
                          <i className="fa-solid fa-circle-plus me-2"></i>Add New Hotel
                          </Link>
                        </div>
                      </>
                    }

                    {!isHotel &&
                      <div className="row my-3 package_section_part p-md-4 p-3">
                        <div className="col-md-4 col-sm-12 px-1 my-2">
                          <label className="required">Adults Price</label>
                          <div className="input-group">
                            <input type="number" value={adults_price} onChange={(e) => setadults_price(e.target.value)} required readOnly={!isAgencyProfile} />
                            <select name="" id="" value={adults_currency} onChange={(e) => setadults_currency(e.target.value)} required readOnly={!isAgencyProfile}>
                              {configurations &&
                                configurations
                                  .filter((data) => data.type.trim().toLowerCase() === 'currency')
                                  .map((data) => (
                                    <option value={data.title} key={data._id}>
                                      {data.title}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12 px-1 my-2">
                          <label className="required">Child Price</label>
                          <div className="input-group">
                            <input type="number" value={childs_price} onChange={(e) => setchilds_price(e.target.value)} required readOnly={!isAgencyProfile} />
                            <select name="" id="" value={childs_currency} onChange={(e) => setchilds_currency(e.target.value)} required readOnly={!isAgencyProfile}>
                              {configurations &&
                                configurations
                                  .filter((data) => data.type.trim().toLowerCase() === 'currency')
                                  .map((data) => (
                                    <option value={data.title} key={data._id}>
                                      {data.title}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 px-1 my-2">
                          <label className="required">Infant Price</label>
                          <div className="input-group">
                            <input type="number" value={infant_price} onChange={(e) => setinfant_price(e.target.value)} required readOnly={!isAgencyProfile} />
                            <select name="" id="" value={infant_currency} onChange={(e) => setinfant_currency(e.target.value)} required readOnly={!isAgencyProfile}>
                              {configurations &&
                                configurations
                                  .filter((data) => data.type.trim().toLowerCase() === 'currency')
                                  .map((data) => (
                                    <option value={data.title} key={data._id}>
                                      {data.title}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    }

                  </div>
                  <hr />
                  {isHotel &&
                    <>
                      <div className="row my-3 package_section_part p-md-4 p-3">
                        <h5 className="mb-2"><i className="fa-solid fa-dollar-sign success_text me-2"></i>Pricing Details</h5>
                        {pricing && pricing.map((row, index) => (
                          <div key={index} className="row my-2">
                            <div className="col-md-2 px-1 my-2">
                              <label htmlFor={`room_type-${index}`} className="required">Room Type</label>
                              <select
                                id={`room_type-${index}`}
                                value={row.room_type}
                                onChange={(e) => handlePricingInputChange(index, 'room_type', e.target.value)}
                                required readOnly={!isAgencyProfile}
                              >
                                <option value="">Select</option>
                                <option value="Self Accomodation">Self Accomodation</option>
                                {configurations && configurations.filter(data => data.type.trim().toLowerCase() === 'room types').map((data, index) => (
                                  <option value={data.title} key={data._id}>{data.title}</option>
                                ))}

                              </select>
                            </div>
                            {['first_price', 'second_price', 'third_price'].map((priceType, idx) => (
                              <div key={idx} className="col-md-3 px-1 my-2">
                                <label className={`${priceType==='first_price'?"required":''}`}>
                                  {priceType === 'first_price'
                                    ? 'Adult Price (greater than 100)'
                                    : priceType === 'second_price'
                                      ? 'Child Price'
                                      : 'Infant Price'}
                                </label>
                                <div className="input-group">
                                  {/* Price Input */}
                                  <input
                                    type="number"
                                    min={`${priceType === 'first_price' ?"100":'0'}`}
                                    className=""
                                    // placeholder= {priceType === 'first_price'
                                    //   ? 'Adult Price'
                                    //   : priceType === 'second_price'
                                    //     ? 'Child Price'
                                    //     : 'Infant Price'}
                                    required={priceType === 'first_price'}
                                    value={row[priceType]?.price || ''}
                                    onChange={(e) =>
                                      handlePricingInputChange(index, `${priceType}.price`, Number(e.target.value))
                                    }

                                    readOnly={!isAgencyProfile}
                                  />
                                  {/* <TextField  label= {priceType === 'first_price'
                                   ? 'Adult Price'
                                   : priceType === 'second_price'
                                     ? 'Child Price'
                                     : 'Infant Price'} value={row[priceType]?.price || ''} // Access price dynamically
                                     onChange={(e) =>
                                       handlePricingInputChange(index, `${priceType}.price`, Number(e.target.value))
                                     }
                                      className='text-field'/> */}

                                  {/* Currency Dropdown */}
                                  <select
                                    className=""
                                    value={row[priceType]?.currency || ''} // Access currency dynamically
                                    onChange={(e) =>
                                      handlePricingInputChange(index, `${priceType}.currency`, e.target.value)
                                    }
                                    readOnly={!isAgencyProfile}
                                  >
                                    {configurations &&
                                      configurations
                                        .filter((data) => data.type.trim().toLowerCase() === 'currency')
                                        .map((data) => (
                                          <option value={data.title} key={data._id}>
                                            {data.title}
                                          </option>
                                        ))}

                                  </select>
                                </div>
                              </div>
                            ))}

                            {index !== 0 && (
                              <div className="col-md-1 pt-2 px-1 my-auto">
                                <button disabled={!isAgencyProfile}
                                  className="btn remove_btn mt-4 pt-1 px-1"
                                  onClick={() => handleDeleteRow(index)}
                                >
                                  <i className="fa-solid fa-xmark"></i>
                                </button>
                              </div>
                            )}
                          </div>
                        ))}

                        {pricing[0]?.room_type?.toLowerCase()!=='self accomodation' &&
                        <div className="col-md-2 px-0">
                        <Link className="btn add_price_btn py-2 px-3" disabled={!isAgencyProfile} onClick={handleAddRow}>
                        <i className="fa-solid fa-circle-plus me-2"></i>Add New Pricing
                        </Link>
                      </div>
                        }
                        
                      </div>
                      <hr />
                    </>
                  }

                  <div className="row my-3 package_section_part p-md-4 p-3">
                    <h5 className="mb-3"><i className="fa-solid fa-van-shuttle red_text me-2"></i>Transportation Types</h5>
                    <div className="d-flex flex-wrap gap-2">
                      {configurations &&
                        configurations
                          .filter((d) => d.type.toLowerCase() === 'transports' && d.isActive)
                          .map((data, index) => (
                            <Chip
                              disabled={!isAgencyProfile}
                              key={index}
                              className="border px-2 py-3 "
                              label={data.title 
                                ? data.title.charAt(0).toUpperCase() + data.title.slice(1) 
                                : ""}                              
                              icon={transport_details === data.title ? undefined : <AddIcon sx={{ fontSize: 0 }} />}
                              onClick={() => handleToggleTransport(data.title)}
                              sx={{
                                fontSize: 14,
                                height:40,
                                borderRadius:100,
                                color: transport_details === data.title ? 'white' : 'black',
                                background: transport_details === data.title ? '#176fec' : '#F2F6FF',
                              }}
                              clickable
                             
                            />
                          ))}

                    </div>
                  </div>
                  <hr />

                  <div className="row my-3 package_section_part p-md-4 p-3">
                    <h5 className="mb-3"><i className="fa-solid fa-route me-2 warning_text"></i>Transportation Trips </h5>
                    <div className="d-flex flex-wrap gap-2">

                      {configurations &&
                        configurations
                          .filter((d) => d.type.toLowerCase() === 'transportation services for' && d.isActive)
                          .map((data, index) => (
                            <Chip
                              disabled={!isAgencyProfile}
                              key={index}
                              className="border px-2 py-3"
                              label={data.title 
                                ? data.title.charAt(0).toUpperCase() + data.title.slice(1) 
                                : ""}                              
                              icon={transport_services_for === data.title ? undefined : <AddIcon sx={{ fontSize: 0 }} />}
                              onClick={() => handleToggleTrasportServicesFor(data.title)}
                              sx={{
                                fontSize: 14,
                                height:40,
                                borderRadius:100,
                                color: transport_services_for === data.title ? 'white' : 'black',
                                background: transport_services_for === data.title ? '#176fec' : '#F2F6FF',
                              }}
                              clickable
                              
                            />
                          ))}
                    </div>
                  </div>
                  <hr />

                  <div className="row my-3 package_section_part p-md-4 p-3">
                    <h5 className="mb-3"><i className="fa-solid fa-house-medical me-2 primary_text"></i>Facilities</h5>
                    <div className="d-flex flex-wrap gap-2">
                      {configurations &&
                        configurations
                          .filter((d) => d.type.toLowerCase() === 'facilities' && d.isActive)
                          .map((data, index) => (
                            <Chip
                              disabled={!isAgencyProfile}
                              key={index}
                              className="border px-2 py-3 "
                              label={data.title 
                                ? data.title.charAt(0).toUpperCase() + data.title.slice(1) 
                                : ""}                              
                              icon={!facilities.includes(data.title) ? <AddIcon sx={{ fontSize: 0 }} /> : undefined}
                              onClick={() => handleToggleFacilities(data.title)}
                              sx={{
                                fontSize: 14,
                                height:40,
                                borderRadius:100,
                                color: facilities.includes(data.title) ? 'white' : 'black',
                                background: facilities.includes(data.title) ?  '#176fec' : '#F2F6FF',
                              }}
                              clickable
                             
                            />
                          ))}

                    </div>
                  </div>
                  <hr />
                  <div className="row my-3 package_section_part p-md-4 p-3">
                    <h5 className="mb-3"><i className="fa-solid fa-mosque me-2 success_text"></i>Ziyarat Included</h5>
                    <div className="d-flex flex-wrap gap-2">
                      {configurations &&
                        configurations
                          .filter((d) => d.type.toLowerCase() === 'ziyarats' && d.isActive)
                          .map((data, index) => (
                            <Chip
                              disabled={!isAgencyProfile}
                              key={index}
                              className="border px-2 py-3 "
                              label={data.title 
                                ? data.title.charAt(0).toUpperCase() + data.title.slice(1) 
                                : ""}                              
                              icon={ziyarat === data.title ? undefined : <AddIcon sx={{ fontSize: 0 }} />}
                              onClick={() => handleToggleZiyarat(data.title)}
                              sx={{
                                fontSize: 14,
                                height:40,
                                borderRadius:100,
                                color: ziyarat === data.title ? 'white' : 'black',
                                background: ziyarat === data.title ? '#176fec' : '#F2F6FF',
                              }}
                              clickable
                              
                            />
                          ))}

                    </div>
                  </div>
                  <hr />

                </div>
                {/* Navigation Buttons */}
                <div className="d-flex justify-content-end mt-4 px-3">
                  <button className="px-3 py-2 cancel_btn me-2" onClick={() => { setNewPackage(false); resetFormStates() }} disabled={loading1}>
                  <i className="fa-solid fa-circle-xmark me-2"></i>Cancel
                  </button>
                  {isAgencyProfile &&
                    <button className="px-3 py-2 submit_btn " disabled={loading1}><i className="fa-solid fa-floppy-disk me-2"></i>{loading1 ? "Saving" : "Save Package"}</button>
                  }

                </div>
              </div>
            </form>
          </div>
        }

      </div>




{/* New Design Modal */}

      <Dialog className='p-0'
        open={openNew}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="container-fluid">
          <div className="row ">
            <div className="col-md-12 px-0 m-0">

              <div className="card add_new_modal px-2">
                <div className="card-header bg-white ">
                  Select design type
                </div>
                <div className="card-body pt-0">
                  <div className="row  py-2">
                    <div className="col-md-12 mt-2 mb-3 px-5 justify-content-between d-flex">
                     
                      <div className="right">
                        <div className="content px-2 py-3 text-center" style={!isNewDesign ? { border: '1px solid var(--primary)' } : {}} onClick={() => setIsNewDesign(false)}>
                          <div className="image p-1">
                            <img src={old_design} alt="" />
                          </div>
                          <button  className="radio_btn btn mt-2" style={!isNewDesign? { background: 'var(--primary)', color: 'white', border: '1px solid var(--primary)' } : {}}>
                            <Radio
                              size="small"
                              checked={!isNewDesign}
                              name="radio-buttons"
                              className="me-auto"
                              style={{
                                padding: "3px",
                                color: !isNewDesign? "white" : "#667085", // Fill radio color when active
                              }}
                              inputProps={{ 'aria-label': 'false' }}
                            />
                             Existing Design
                          </button>
                        </div>
                      </div>

                      <div className="right">
                        <div className="content px-2 py-3 text-center" style={isNewDesign ? { border: '1px solid var(--primary)' } : {}} onClick={() => setIsNewDesign(true)}>
                          <div className="image p-1">
                            <img src={new_design} alt="" />
                          </div>
                          <button  className="radio_btn btn mt-2" style={isNewDesign? { background: 'var(--primary)', color: 'white', border: '1px solid var(--primary)' } : {}}>
                            <Radio
                              size="small"
                              checked={isNewDesign}
                              name="radio-buttons"
                              className="me-auto"
                              style={{
                                padding: "3px",
                                color: isNewDesign? "white" : "#667085", // Fill radio color when active
                              }}
                              inputProps={{ 'aria-label': 'true' }}
                            />
                             New Updated Design
                          </button>
                        </div>
                      </div>


                    </div>
                    <div className="d-flex justify-content-between mt-1 pb-0">
                      <button className="btn cancel_btn mx-2  py-2" type='button' onClick={() => handleCloseNew()} disabled={loading1}>Cancel</button>
                      <button className="btn save_btn mx-2 " onClick={() => { handleNewPackage() }}>Next</button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </Dialog>
{/*       
      <Dialog className='p-0'
        open={openNew}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="container-fluid">
          <div className="row ">
            <div className="col-md-12 px-0 m-0">

              <div className="card add_new_modal px-2">
                <div className="card-header bg-white ">
                  Select package type
                </div>
                <div className="card-body pt-0">
                  <div className="row  py-2">
                    <div className="col-md-12 mt-2 mb-3 px-5 justify-content-between d-flex">
                      <div className="left ">
                        <div className="content px-2 py-3 text-center" style={package_header === 'hajj package' ? { border: '1px solid var(--primary)' } : {}} onClick={() => setpackage_header('hajj package')}>
                          <div className="image p-1">
                            <img src={hajj_package} alt="" />
                          </div>
                          <button onClick={() => setpackage_header('hajj package')} className="radio_btn btn mt-2" style={package_header === 'hajj package' ? { background: 'var(--primary)', color: 'white', border: '1px solid var(--primary)' } : {}}>
                            <Radio
                              size="small"
                              checked={package_header === 'hajj package'}
                              name="radio-buttons"
                              className="me-auto"
                              style={{
                                padding: "3px",
                                color: package_header === 'hajj package' ? "white" : "#667085", // Fill radio color when active
                              }}
                              inputProps={{ 'aria-label': ' Hajj Package' }}
                            />
                            Hajj Package
                          </button>
                        </div>
                      </div>
                      <div className="right">
                        <div className="content px-2 py-3 text-center" style={package_header === 'umrah package' ? { border: '1px solid var(--primary)' } : {}} onClick={() => setpackage_header('umrah package')}>
                          <div className="image p-1">
                            <img src={umrah_package} alt="" />
                          </div>
                          <button onClick={() => setpackage_header('umrah package')} className="radio_btn btn mt-2" style={package_header === 'umrah package' ? { background: 'var(--primary)', color: 'white', border: '1px solid var(--primary)' } : {}}>
                            <Radio
                              size="small"
                              checked={package_header === 'umrah package'}
                              name="radio-buttons"
                              className="me-auto"
                              style={{
                                padding: "3px",
                                color: package_header === 'umrah package' ? "white" : "#667085", // Fill radio color when active
                              }}
                              inputProps={{ 'aria-label': ' umrah package' }}
                            />
                            Umrah Package
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between mt-1 pb-0">
                      <button className="btn cancel_btn mx-2  py-2" type='button' onClick={() => handleCloseNew()} disabled={loading1}>Cancel</button>
                      <button className="btn save_btn mx-2 " onClick={() => { handleNewPackage() }}>Next</button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </Dialog> */}


    </div>
  );
}